import React from "react";

/**
 * WorldMapDots
 * A dotted world map rendered as inline SVG (no image request, fully styleable).
 * Dot color follows `color` (defaults to currentColor, so a Tailwind text-* class works).
 *
 * Usage:
 *   <WorldMapDots className="fixed top-0 right-20 z-0 w-[40%] opacity-20 text-slate-400" />
 */
export default function WorldMapDots({ className = "", color = "#0ab39c" }) {
  return (
    <svg
      viewBox="0 0 99 50"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill={color}
      aria-hidden="true"
    >
      <circle cx="3.5" cy="0" r="0.24" />
      <circle cx="15.5" cy="0" r="0.24" />
      <circle cx="16.5" cy="0" r="0.24" />
      <circle cx="17.5" cy="0" r="0.24" />
      <circle cx="18.5" cy="0" r="0.24" />
      <circle cx="21.5" cy="0" r="0.24" />
      <circle cx="23.5" cy="0" r="0.24" />
      <circle cx="24.5" cy="0" r="0.24" />
      <circle cx="25.5" cy="0" r="0.24" />
      <circle cx="26.5" cy="0" r="0.24" />
      <circle cx="27.5" cy="0" r="0.24" />
      <circle cx="34.5" cy="0" r="0.24" />
      <circle cx="35.5" cy="0" r="0.24" />
      <circle cx="36.5" cy="0" r="0.24" />
      <circle cx="37.5" cy="0" r="0.24" />
      <circle cx="38.5" cy="0" r="0.24" />
      <circle cx="39.5" cy="0" r="0.24" />
      <circle cx="40.5" cy="0" r="0.24" />
      <circle cx="41.5" cy="0" r="0.24" />
      <circle cx="42.5" cy="0" r="0.24" />
      <circle cx="57.5" cy="0" r="0.24" />
      <circle cx="65.5" cy="0" r="0.24" />
      <circle cx="69.5" cy="0" r="0.24" />
      <circle cx="70.5" cy="0" r="0.24" />
      <circle cx="71.5" cy="0" r="0.24" />
      <circle cx="72.5" cy="0" r="0.24" />
      <circle cx="73.5" cy="0" r="0.24" />
      <circle cx="74.5" cy="0" r="0.24" />
      <circle cx="75.5" cy="0" r="0.24" />
      <circle cx="76.5" cy="0" r="0.24" />
      <circle cx="77.5" cy="0" r="0.24" />
      <circle cx="78.5" cy="0" r="0.24" />
      <circle cx="79.5" cy="0" r="0.24" />
      <circle cx="80.5" cy="0" r="0.24" />
      <circle cx="81.5" cy="0" r="0.24" />
      <circle cx="82.5" cy="0" r="0.24" />
      <circle cx="83.5" cy="0" r="0.24" />
      <circle cx="84.5" cy="0" r="0.24" />
      <circle cx="85.5" cy="0" r="0.24" />
      <circle cx="86.5" cy="0" r="0.24" />
      <circle cx="87.5" cy="0" r="0.24" />
      <circle cx="88.5" cy="0" r="0.24" />
      <circle cx="89.5" cy="0" r="0.24" />
      <circle cx="90.5" cy="0" r="0.24" />
      <circle cx="91.5" cy="0" r="0.24" />
      <circle cx="92.5" cy="0" r="0.24" />
      <circle cx="93.5" cy="0" r="0.24" />
      <circle cx="2" cy="0.8660254037844386" r="0.24" />
      <circle cx="3" cy="0.8660254037844386" r="0.24" />
      <circle cx="4" cy="0.8660254037844386" r="0.24" />
      <circle cx="5" cy="0.8660254037844386" r="0.24" />
      <circle cx="6" cy="0.8660254037844386" r="0.24" />
      <circle cx="7" cy="0.8660254037844386" r="0.24" />
      <circle cx="11" cy="0.8660254037844386" r="0.24" />
      <circle cx="12" cy="0.8660254037844386" r="0.24" />
      <circle cx="16" cy="0.8660254037844386" r="0.24" />
      <circle cx="17" cy="0.8660254037844386" r="0.24" />
      <circle cx="18" cy="0.8660254037844386" r="0.24" />
      <circle cx="19" cy="0.8660254037844386" r="0.24" />
      <circle cx="22" cy="0.8660254037844386" r="0.24" />
      <circle cx="25" cy="0.8660254037844386" r="0.24" />
      <circle cx="26" cy="0.8660254037844386" r="0.24" />
      <circle cx="27" cy="0.8660254037844386" r="0.24" />
      <circle cx="28" cy="0.8660254037844386" r="0.24" />
      <circle cx="29" cy="0.8660254037844386" r="0.24" />
      <circle cx="34" cy="0.8660254037844386" r="0.24" />
      <circle cx="35" cy="0.8660254037844386" r="0.24" />
      <circle cx="36" cy="0.8660254037844386" r="0.24" />
      <circle cx="37" cy="0.8660254037844386" r="0.24" />
      <circle cx="38" cy="0.8660254037844386" r="0.24" />
      <circle cx="39" cy="0.8660254037844386" r="0.24" />
      <circle cx="40" cy="0.8660254037844386" r="0.24" />
      <circle cx="41" cy="0.8660254037844386" r="0.24" />
      <circle cx="42" cy="0.8660254037844386" r="0.24" />
      <circle cx="56" cy="0.8660254037844386" r="0.24" />
      <circle cx="57" cy="0.8660254037844386" r="0.24" />
      <circle cx="58" cy="0.8660254037844386" r="0.24" />
      <circle cx="70" cy="0.8660254037844386" r="0.24" />
      <circle cx="72" cy="0.8660254037844386" r="0.24" />
      <circle cx="73" cy="0.8660254037844386" r="0.24" />
      <circle cx="74" cy="0.8660254037844386" r="0.24" />
      <circle cx="75" cy="0.8660254037844386" r="0.24" />
      <circle cx="76" cy="0.8660254037844386" r="0.24" />
      <circle cx="77" cy="0.8660254037844386" r="0.24" />
      <circle cx="78" cy="0.8660254037844386" r="0.24" />
      <circle cx="79" cy="0.8660254037844386" r="0.24" />
      <circle cx="80" cy="0.8660254037844386" r="0.24" />
      <circle cx="81" cy="0.8660254037844386" r="0.24" />
      <circle cx="82" cy="0.8660254037844386" r="0.24" />
      <circle cx="83" cy="0.8660254037844386" r="0.24" />
      <circle cx="84" cy="0.8660254037844386" r="0.24" />
      <circle cx="85" cy="0.8660254037844386" r="0.24" />
      <circle cx="86" cy="0.8660254037844386" r="0.24" />
      <circle cx="87" cy="0.8660254037844386" r="0.24" />
      <circle cx="88" cy="0.8660254037844386" r="0.24" />
      <circle cx="89" cy="0.8660254037844386" r="0.24" />
      <circle cx="90" cy="0.8660254037844386" r="0.24" />
      <circle cx="91" cy="0.8660254037844386" r="0.24" />
      <circle cx="92" cy="0.8660254037844386" r="0.24" />
      <circle cx="93" cy="0.8660254037844386" r="0.24" />
      <circle cx="94" cy="0.8660254037844386" r="0.24" />
      <circle cx="95" cy="0.8660254037844386" r="0.24" />
      <circle cx="96" cy="0.8660254037844386" r="0.24" />
      <circle cx="1.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="2.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="3.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="4.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="5.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="6.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="7.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="8.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="9.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="10.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="11.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="12.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="13.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="14.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="16.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="17.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="20.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="22.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="24.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="25.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="27.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="28.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="29.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="34.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="35.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="36.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="37.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="38.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="39.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="40.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="41.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="55.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="56.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="57.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="58.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="59.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="67.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="68.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="70.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="72.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="73.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="74.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="75.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="76.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="77.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="78.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="79.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="80.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="81.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="82.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="83.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="84.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="85.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="86.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="87.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="88.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="89.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="90.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="91.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="92.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="93.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="94.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="95.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="96.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="97.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="98.5" cy="1.7320508075688772" r="0.24" />
      <circle cx="1" cy="2.598076211353316" r="0.24" />
      <circle cx="2" cy="2.598076211353316" r="0.24" />
      <circle cx="3" cy="2.598076211353316" r="0.24" />
      <circle cx="4" cy="2.598076211353316" r="0.24" />
      <circle cx="5" cy="2.598076211353316" r="0.24" />
      <circle cx="6" cy="2.598076211353316" r="0.24" />
      <circle cx="7" cy="2.598076211353316" r="0.24" />
      <circle cx="8" cy="2.598076211353316" r="0.24" />
      <circle cx="9" cy="2.598076211353316" r="0.24" />
      <circle cx="10" cy="2.598076211353316" r="0.24" />
      <circle cx="11" cy="2.598076211353316" r="0.24" />
      <circle cx="12" cy="2.598076211353316" r="0.24" />
      <circle cx="13" cy="2.598076211353316" r="0.24" />
      <circle cx="14" cy="2.598076211353316" r="0.24" />
      <circle cx="15" cy="2.598076211353316" r="0.24" />
      <circle cx="18" cy="2.598076211353316" r="0.24" />
      <circle cx="19" cy="2.598076211353316" r="0.24" />
      <circle cx="21" cy="2.598076211353316" r="0.24" />
      <circle cx="22" cy="2.598076211353316" r="0.24" />
      <circle cx="23" cy="2.598076211353316" r="0.24" />
      <circle cx="25" cy="2.598076211353316" r="0.24" />
      <circle cx="27" cy="2.598076211353316" r="0.24" />
      <circle cx="28" cy="2.598076211353316" r="0.24" />
      <circle cx="29" cy="2.598076211353316" r="0.24" />
      <circle cx="30" cy="2.598076211353316" r="0.24" />
      <circle cx="34" cy="2.598076211353316" r="0.24" />
      <circle cx="35" cy="2.598076211353316" r="0.24" />
      <circle cx="36" cy="2.598076211353316" r="0.24" />
      <circle cx="37" cy="2.598076211353316" r="0.24" />
      <circle cx="38" cy="2.598076211353316" r="0.24" />
      <circle cx="39" cy="2.598076211353316" r="0.24" />
      <circle cx="54" cy="2.598076211353316" r="0.24" />
      <circle cx="55" cy="2.598076211353316" r="0.24" />
      <circle cx="56" cy="2.598076211353316" r="0.24" />
      <circle cx="57" cy="2.598076211353316" r="0.24" />
      <circle cx="58" cy="2.598076211353316" r="0.24" />
      <circle cx="59" cy="2.598076211353316" r="0.24" />
      <circle cx="60" cy="2.598076211353316" r="0.24" />
      <circle cx="61" cy="2.598076211353316" r="0.24" />
      <circle cx="63" cy="2.598076211353316" r="0.24" />
      <circle cx="65" cy="2.598076211353316" r="0.24" />
      <circle cx="66" cy="2.598076211353316" r="0.24" />
      <circle cx="67" cy="2.598076211353316" r="0.24" />
      <circle cx="68" cy="2.598076211353316" r="0.24" />
      <circle cx="69" cy="2.598076211353316" r="0.24" />
      <circle cx="70" cy="2.598076211353316" r="0.24" />
      <circle cx="71" cy="2.598076211353316" r="0.24" />
      <circle cx="72" cy="2.598076211353316" r="0.24" />
      <circle cx="73" cy="2.598076211353316" r="0.24" />
      <circle cx="74" cy="2.598076211353316" r="0.24" />
      <circle cx="75" cy="2.598076211353316" r="0.24" />
      <circle cx="76" cy="2.598076211353316" r="0.24" />
      <circle cx="77" cy="2.598076211353316" r="0.24" />
      <circle cx="78" cy="2.598076211353316" r="0.24" />
      <circle cx="79" cy="2.598076211353316" r="0.24" />
      <circle cx="80" cy="2.598076211353316" r="0.24" />
      <circle cx="81" cy="2.598076211353316" r="0.24" />
      <circle cx="82" cy="2.598076211353316" r="0.24" />
      <circle cx="83" cy="2.598076211353316" r="0.24" />
      <circle cx="84" cy="2.598076211353316" r="0.24" />
      <circle cx="85" cy="2.598076211353316" r="0.24" />
      <circle cx="86" cy="2.598076211353316" r="0.24" />
      <circle cx="87" cy="2.598076211353316" r="0.24" />
      <circle cx="88" cy="2.598076211353316" r="0.24" />
      <circle cx="89" cy="2.598076211353316" r="0.24" />
      <circle cx="90" cy="2.598076211353316" r="0.24" />
      <circle cx="91" cy="2.598076211353316" r="0.24" />
      <circle cx="92" cy="2.598076211353316" r="0.24" />
      <circle cx="93" cy="2.598076211353316" r="0.24" />
      <circle cx="94" cy="2.598076211353316" r="0.24" />
      <circle cx="95" cy="2.598076211353316" r="0.24" />
      <circle cx="96" cy="2.598076211353316" r="0.24" />
      <circle cx="97" cy="2.598076211353316" r="0.24" />
      <circle cx="98" cy="2.598076211353316" r="0.24" />
      <circle cx="2.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="3.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="4.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="5.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="6.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="7.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="8.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="9.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="10.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="11.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="12.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="13.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="14.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="15.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="16.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="17.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="18.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="19.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="20.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="21.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="22.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="23.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="24.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="28.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="29.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="30.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="34.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="35.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="36.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="37.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="38.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="53.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="54.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="55.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="56.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="57.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="58.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="59.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="60.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="61.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="63.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="64.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="65.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="66.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="67.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="68.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="69.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="70.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="71.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="72.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="73.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="74.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="75.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="76.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="77.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="78.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="79.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="80.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="81.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="82.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="83.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="84.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="85.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="86.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="87.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="88.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="89.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="90.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="91.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="92.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="93.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="94.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="95.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="96.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="97.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="98.5" cy="3.4641016151377544" r="0.24" />
      <circle cx="1" cy="4.330127018922193" r="0.24" />
      <circle cx="2" cy="4.330127018922193" r="0.24" />
      <circle cx="3" cy="4.330127018922193" r="0.24" />
      <circle cx="4" cy="4.330127018922193" r="0.24" />
      <circle cx="5" cy="4.330127018922193" r="0.24" />
      <circle cx="6" cy="4.330127018922193" r="0.24" />
      <circle cx="7" cy="4.330127018922193" r="0.24" />
      <circle cx="8" cy="4.330127018922193" r="0.24" />
      <circle cx="9" cy="4.330127018922193" r="0.24" />
      <circle cx="10" cy="4.330127018922193" r="0.24" />
      <circle cx="11" cy="4.330127018922193" r="0.24" />
      <circle cx="12" cy="4.330127018922193" r="0.24" />
      <circle cx="13" cy="4.330127018922193" r="0.24" />
      <circle cx="14" cy="4.330127018922193" r="0.24" />
      <circle cx="15" cy="4.330127018922193" r="0.24" />
      <circle cx="16" cy="4.330127018922193" r="0.24" />
      <circle cx="17" cy="4.330127018922193" r="0.24" />
      <circle cx="18" cy="4.330127018922193" r="0.24" />
      <circle cx="19" cy="4.330127018922193" r="0.24" />
      <circle cx="20" cy="4.330127018922193" r="0.24" />
      <circle cx="21" cy="4.330127018922193" r="0.24" />
      <circle cx="22" cy="4.330127018922193" r="0.24" />
      <circle cx="23" cy="4.330127018922193" r="0.24" />
      <circle cx="28" cy="4.330127018922193" r="0.24" />
      <circle cx="29" cy="4.330127018922193" r="0.24" />
      <circle cx="34" cy="4.330127018922193" r="0.24" />
      <circle cx="35" cy="4.330127018922193" r="0.24" />
      <circle cx="36" cy="4.330127018922193" r="0.24" />
      <circle cx="37" cy="4.330127018922193" r="0.24" />
      <circle cx="38" cy="4.330127018922193" r="0.24" />
      <circle cx="43" cy="4.330127018922193" r="0.24" />
      <circle cx="44" cy="4.330127018922193" r="0.24" />
      <circle cx="45" cy="4.330127018922193" r="0.24" />
      <circle cx="54" cy="4.330127018922193" r="0.24" />
      <circle cx="55" cy="4.330127018922193" r="0.24" />
      <circle cx="57" cy="4.330127018922193" r="0.24" />
      <circle cx="58" cy="4.330127018922193" r="0.24" />
      <circle cx="59" cy="4.330127018922193" r="0.24" />
      <circle cx="62" cy="4.330127018922193" r="0.24" />
      <circle cx="63" cy="4.330127018922193" r="0.24" />
      <circle cx="64" cy="4.330127018922193" r="0.24" />
      <circle cx="65" cy="4.330127018922193" r="0.24" />
      <circle cx="66" cy="4.330127018922193" r="0.24" />
      <circle cx="67" cy="4.330127018922193" r="0.24" />
      <circle cx="68" cy="4.330127018922193" r="0.24" />
      <circle cx="69" cy="4.330127018922193" r="0.24" />
      <circle cx="70" cy="4.330127018922193" r="0.24" />
      <circle cx="71" cy="4.330127018922193" r="0.24" />
      <circle cx="72" cy="4.330127018922193" r="0.24" />
      <circle cx="73" cy="4.330127018922193" r="0.24" />
      <circle cx="74" cy="4.330127018922193" r="0.24" />
      <circle cx="75" cy="4.330127018922193" r="0.24" />
      <circle cx="76" cy="4.330127018922193" r="0.24" />
      <circle cx="77" cy="4.330127018922193" r="0.24" />
      <circle cx="78" cy="4.330127018922193" r="0.24" />
      <circle cx="79" cy="4.330127018922193" r="0.24" />
      <circle cx="80" cy="4.330127018922193" r="0.24" />
      <circle cx="81" cy="4.330127018922193" r="0.24" />
      <circle cx="82" cy="4.330127018922193" r="0.24" />
      <circle cx="83" cy="4.330127018922193" r="0.24" />
      <circle cx="84" cy="4.330127018922193" r="0.24" />
      <circle cx="85" cy="4.330127018922193" r="0.24" />
      <circle cx="86" cy="4.330127018922193" r="0.24" />
      <circle cx="87" cy="4.330127018922193" r="0.24" />
      <circle cx="88" cy="4.330127018922193" r="0.24" />
      <circle cx="89" cy="4.330127018922193" r="0.24" />
      <circle cx="90" cy="4.330127018922193" r="0.24" />
      <circle cx="91" cy="4.330127018922193" r="0.24" />
      <circle cx="92" cy="4.330127018922193" r="0.24" />
      <circle cx="93" cy="4.330127018922193" r="0.24" />
      <circle cx="94" cy="4.330127018922193" r="0.24" />
      <circle cx="95" cy="4.330127018922193" r="0.24" />
      <circle cx="96" cy="4.330127018922193" r="0.24" />
      <circle cx="97" cy="4.330127018922193" r="0.24" />
      <circle cx="98" cy="4.330127018922193" r="0.24" />
      <circle cx="2.5" cy="5.196152422706632" r="0.24" />
      <circle cx="3.5" cy="5.196152422706632" r="0.24" />
      <circle cx="4.5" cy="5.196152422706632" r="0.24" />
      <circle cx="5.5" cy="5.196152422706632" r="0.24" />
      <circle cx="6.5" cy="5.196152422706632" r="0.24" />
      <circle cx="7.5" cy="5.196152422706632" r="0.24" />
      <circle cx="8.5" cy="5.196152422706632" r="0.24" />
      <circle cx="9.5" cy="5.196152422706632" r="0.24" />
      <circle cx="10.5" cy="5.196152422706632" r="0.24" />
      <circle cx="11.5" cy="5.196152422706632" r="0.24" />
      <circle cx="12.5" cy="5.196152422706632" r="0.24" />
      <circle cx="13.5" cy="5.196152422706632" r="0.24" />
      <circle cx="14.5" cy="5.196152422706632" r="0.24" />
      <circle cx="15.5" cy="5.196152422706632" r="0.24" />
      <circle cx="16.5" cy="5.196152422706632" r="0.24" />
      <circle cx="17.5" cy="5.196152422706632" r="0.24" />
      <circle cx="18.5" cy="5.196152422706632" r="0.24" />
      <circle cx="19.5" cy="5.196152422706632" r="0.24" />
      <circle cx="20.5" cy="5.196152422706632" r="0.24" />
      <circle cx="21.5" cy="5.196152422706632" r="0.24" />
      <circle cx="22.5" cy="5.196152422706632" r="0.24" />
      <circle cx="23.5" cy="5.196152422706632" r="0.24" />
      <circle cx="24.5" cy="5.196152422706632" r="0.24" />
      <circle cx="28.5" cy="5.196152422706632" r="0.24" />
      <circle cx="29.5" cy="5.196152422706632" r="0.24" />
      <circle cx="34.5" cy="5.196152422706632" r="0.24" />
      <circle cx="35.5" cy="5.196152422706632" r="0.24" />
      <circle cx="36.5" cy="5.196152422706632" r="0.24" />
      <circle cx="37.5" cy="5.196152422706632" r="0.24" />
      <circle cx="43.5" cy="5.196152422706632" r="0.24" />
      <circle cx="44.5" cy="5.196152422706632" r="0.24" />
      <circle cx="53.5" cy="5.196152422706632" r="0.24" />
      <circle cx="54.5" cy="5.196152422706632" r="0.24" />
      <circle cx="55.5" cy="5.196152422706632" r="0.24" />
      <circle cx="56.5" cy="5.196152422706632" r="0.24" />
      <circle cx="57.5" cy="5.196152422706632" r="0.24" />
      <circle cx="58.5" cy="5.196152422706632" r="0.24" />
      <circle cx="59.5" cy="5.196152422706632" r="0.24" />
      <circle cx="60.5" cy="5.196152422706632" r="0.24" />
      <circle cx="61.5" cy="5.196152422706632" r="0.24" />
      <circle cx="62.5" cy="5.196152422706632" r="0.24" />
      <circle cx="63.5" cy="5.196152422706632" r="0.24" />
      <circle cx="64.5" cy="5.196152422706632" r="0.24" />
      <circle cx="65.5" cy="5.196152422706632" r="0.24" />
      <circle cx="66.5" cy="5.196152422706632" r="0.24" />
      <circle cx="67.5" cy="5.196152422706632" r="0.24" />
      <circle cx="68.5" cy="5.196152422706632" r="0.24" />
      <circle cx="69.5" cy="5.196152422706632" r="0.24" />
      <circle cx="70.5" cy="5.196152422706632" r="0.24" />
      <circle cx="71.5" cy="5.196152422706632" r="0.24" />
      <circle cx="72.5" cy="5.196152422706632" r="0.24" />
      <circle cx="73.5" cy="5.196152422706632" r="0.24" />
      <circle cx="74.5" cy="5.196152422706632" r="0.24" />
      <circle cx="75.5" cy="5.196152422706632" r="0.24" />
      <circle cx="76.5" cy="5.196152422706632" r="0.24" />
      <circle cx="77.5" cy="5.196152422706632" r="0.24" />
      <circle cx="78.5" cy="5.196152422706632" r="0.24" />
      <circle cx="79.5" cy="5.196152422706632" r="0.24" />
      <circle cx="80.5" cy="5.196152422706632" r="0.24" />
      <circle cx="81.5" cy="5.196152422706632" r="0.24" />
      <circle cx="82.5" cy="5.196152422706632" r="0.24" />
      <circle cx="83.5" cy="5.196152422706632" r="0.24" />
      <circle cx="84.5" cy="5.196152422706632" r="0.24" />
      <circle cx="85.5" cy="5.196152422706632" r="0.24" />
      <circle cx="86.5" cy="5.196152422706632" r="0.24" />
      <circle cx="87.5" cy="5.196152422706632" r="0.24" />
      <circle cx="88.5" cy="5.196152422706632" r="0.24" />
      <circle cx="89.5" cy="5.196152422706632" r="0.24" />
      <circle cx="90.5" cy="5.196152422706632" r="0.24" />
      <circle cx="91.5" cy="5.196152422706632" r="0.24" />
      <circle cx="92.5" cy="5.196152422706632" r="0.24" />
      <circle cx="93.5" cy="5.196152422706632" r="0.24" />
      <circle cx="94.5" cy="5.196152422706632" r="0.24" />
      <circle cx="95.5" cy="5.196152422706632" r="0.24" />
      <circle cx="96.5" cy="5.196152422706632" r="0.24" />
      <circle cx="97.5" cy="5.196152422706632" r="0.24" />
      <circle cx="98.5" cy="5.196152422706632" r="0.24" />
      <circle cx="1" cy="6.06217782649107" r="0.24" />
      <circle cx="2" cy="6.06217782649107" r="0.24" />
      <circle cx="3" cy="6.06217782649107" r="0.24" />
      <circle cx="4" cy="6.06217782649107" r="0.24" />
      <circle cx="5" cy="6.06217782649107" r="0.24" />
      <circle cx="6" cy="6.06217782649107" r="0.24" />
      <circle cx="7" cy="6.06217782649107" r="0.24" />
      <circle cx="8" cy="6.06217782649107" r="0.24" />
      <circle cx="9" cy="6.06217782649107" r="0.24" />
      <circle cx="10" cy="6.06217782649107" r="0.24" />
      <circle cx="11" cy="6.06217782649107" r="0.24" />
      <circle cx="12" cy="6.06217782649107" r="0.24" />
      <circle cx="13" cy="6.06217782649107" r="0.24" />
      <circle cx="14" cy="6.06217782649107" r="0.24" />
      <circle cx="15" cy="6.06217782649107" r="0.24" />
      <circle cx="16" cy="6.06217782649107" r="0.24" />
      <circle cx="17" cy="6.06217782649107" r="0.24" />
      <circle cx="18" cy="6.06217782649107" r="0.24" />
      <circle cx="19" cy="6.06217782649107" r="0.24" />
      <circle cx="20" cy="6.06217782649107" r="0.24" />
      <circle cx="21" cy="6.06217782649107" r="0.24" />
      <circle cx="22" cy="6.06217782649107" r="0.24" />
      <circle cx="29" cy="6.06217782649107" r="0.24" />
      <circle cx="30" cy="6.06217782649107" r="0.24" />
      <circle cx="35" cy="6.06217782649107" r="0.24" />
      <circle cx="36" cy="6.06217782649107" r="0.24" />
      <circle cx="37" cy="6.06217782649107" r="0.24" />
      <circle cx="52" cy="6.06217782649107" r="0.24" />
      <circle cx="53" cy="6.06217782649107" r="0.24" />
      <circle cx="54" cy="6.06217782649107" r="0.24" />
      <circle cx="56" cy="6.06217782649107" r="0.24" />
      <circle cx="57" cy="6.06217782649107" r="0.24" />
      <circle cx="58" cy="6.06217782649107" r="0.24" />
      <circle cx="59" cy="6.06217782649107" r="0.24" />
      <circle cx="60" cy="6.06217782649107" r="0.24" />
      <circle cx="61" cy="6.06217782649107" r="0.24" />
      <circle cx="62" cy="6.06217782649107" r="0.24" />
      <circle cx="63" cy="6.06217782649107" r="0.24" />
      <circle cx="64" cy="6.06217782649107" r="0.24" />
      <circle cx="65" cy="6.06217782649107" r="0.24" />
      <circle cx="66" cy="6.06217782649107" r="0.24" />
      <circle cx="67" cy="6.06217782649107" r="0.24" />
      <circle cx="68" cy="6.06217782649107" r="0.24" />
      <circle cx="69" cy="6.06217782649107" r="0.24" />
      <circle cx="70" cy="6.06217782649107" r="0.24" />
      <circle cx="71" cy="6.06217782649107" r="0.24" />
      <circle cx="72" cy="6.06217782649107" r="0.24" />
      <circle cx="73" cy="6.06217782649107" r="0.24" />
      <circle cx="74" cy="6.06217782649107" r="0.24" />
      <circle cx="75" cy="6.06217782649107" r="0.24" />
      <circle cx="76" cy="6.06217782649107" r="0.24" />
      <circle cx="77" cy="6.06217782649107" r="0.24" />
      <circle cx="78" cy="6.06217782649107" r="0.24" />
      <circle cx="79" cy="6.06217782649107" r="0.24" />
      <circle cx="80" cy="6.06217782649107" r="0.24" />
      <circle cx="81" cy="6.06217782649107" r="0.24" />
      <circle cx="82" cy="6.06217782649107" r="0.24" />
      <circle cx="83" cy="6.06217782649107" r="0.24" />
      <circle cx="84" cy="6.06217782649107" r="0.24" />
      <circle cx="85" cy="6.06217782649107" r="0.24" />
      <circle cx="86" cy="6.06217782649107" r="0.24" />
      <circle cx="87" cy="6.06217782649107" r="0.24" />
      <circle cx="88" cy="6.06217782649107" r="0.24" />
      <circle cx="89" cy="6.06217782649107" r="0.24" />
      <circle cx="90" cy="6.06217782649107" r="0.24" />
      <circle cx="91" cy="6.06217782649107" r="0.24" />
      <circle cx="92" cy="6.06217782649107" r="0.24" />
      <circle cx="93" cy="6.06217782649107" r="0.24" />
      <circle cx="94" cy="6.06217782649107" r="0.24" />
      <circle cx="95" cy="6.06217782649107" r="0.24" />
      <circle cx="96" cy="6.06217782649107" r="0.24" />
      <circle cx="97" cy="6.06217782649107" r="0.24" />
      <circle cx="98" cy="6.06217782649107" r="0.24" />
      <circle cx="1.5" cy="6.928203230275509" r="0.24" />
      <circle cx="2.5" cy="6.928203230275509" r="0.24" />
      <circle cx="3.5" cy="6.928203230275509" r="0.24" />
      <circle cx="4.5" cy="6.928203230275509" r="0.24" />
      <circle cx="5.5" cy="6.928203230275509" r="0.24" />
      <circle cx="6.5" cy="6.928203230275509" r="0.24" />
      <circle cx="7.5" cy="6.928203230275509" r="0.24" />
      <circle cx="8.5" cy="6.928203230275509" r="0.24" />
      <circle cx="9.5" cy="6.928203230275509" r="0.24" />
      <circle cx="10.5" cy="6.928203230275509" r="0.24" />
      <circle cx="11.5" cy="6.928203230275509" r="0.24" />
      <circle cx="12.5" cy="6.928203230275509" r="0.24" />
      <circle cx="13.5" cy="6.928203230275509" r="0.24" />
      <circle cx="14.5" cy="6.928203230275509" r="0.24" />
      <circle cx="15.5" cy="6.928203230275509" r="0.24" />
      <circle cx="16.5" cy="6.928203230275509" r="0.24" />
      <circle cx="17.5" cy="6.928203230275509" r="0.24" />
      <circle cx="18.5" cy="6.928203230275509" r="0.24" />
      <circle cx="19.5" cy="6.928203230275509" r="0.24" />
      <circle cx="20.5" cy="6.928203230275509" r="0.24" />
      <circle cx="21.5" cy="6.928203230275509" r="0.24" />
      <circle cx="27.5" cy="6.928203230275509" r="0.24" />
      <circle cx="35.5" cy="6.928203230275509" r="0.24" />
      <circle cx="36.5" cy="6.928203230275509" r="0.24" />
      <circle cx="51.5" cy="6.928203230275509" r="0.24" />
      <circle cx="52.5" cy="6.928203230275509" r="0.24" />
      <circle cx="53.5" cy="6.928203230275509" r="0.24" />
      <circle cx="54.5" cy="6.928203230275509" r="0.24" />
      <circle cx="56.5" cy="6.928203230275509" r="0.24" />
      <circle cx="57.5" cy="6.928203230275509" r="0.24" />
      <circle cx="58.5" cy="6.928203230275509" r="0.24" />
      <circle cx="59.5" cy="6.928203230275509" r="0.24" />
      <circle cx="60.5" cy="6.928203230275509" r="0.24" />
      <circle cx="61.5" cy="6.928203230275509" r="0.24" />
      <circle cx="62.5" cy="6.928203230275509" r="0.24" />
      <circle cx="63.5" cy="6.928203230275509" r="0.24" />
      <circle cx="64.5" cy="6.928203230275509" r="0.24" />
      <circle cx="65.5" cy="6.928203230275509" r="0.24" />
      <circle cx="66.5" cy="6.928203230275509" r="0.24" />
      <circle cx="67.5" cy="6.928203230275509" r="0.24" />
      <circle cx="68.5" cy="6.928203230275509" r="0.24" />
      <circle cx="69.5" cy="6.928203230275509" r="0.24" />
      <circle cx="70.5" cy="6.928203230275509" r="0.24" />
      <circle cx="71.5" cy="6.928203230275509" r="0.24" />
      <circle cx="72.5" cy="6.928203230275509" r="0.24" />
      <circle cx="73.5" cy="6.928203230275509" r="0.24" />
      <circle cx="74.5" cy="6.928203230275509" r="0.24" />
      <circle cx="75.5" cy="6.928203230275509" r="0.24" />
      <circle cx="76.5" cy="6.928203230275509" r="0.24" />
      <circle cx="77.5" cy="6.928203230275509" r="0.24" />
      <circle cx="78.5" cy="6.928203230275509" r="0.24" />
      <circle cx="79.5" cy="6.928203230275509" r="0.24" />
      <circle cx="80.5" cy="6.928203230275509" r="0.24" />
      <circle cx="81.5" cy="6.928203230275509" r="0.24" />
      <circle cx="82.5" cy="6.928203230275509" r="0.24" />
      <circle cx="83.5" cy="6.928203230275509" r="0.24" />
      <circle cx="84.5" cy="6.928203230275509" r="0.24" />
      <circle cx="85.5" cy="6.928203230275509" r="0.24" />
      <circle cx="86.5" cy="6.928203230275509" r="0.24" />
      <circle cx="87.5" cy="6.928203230275509" r="0.24" />
      <circle cx="88.5" cy="6.928203230275509" r="0.24" />
      <circle cx="89.5" cy="6.928203230275509" r="0.24" />
      <circle cx="90.5" cy="6.928203230275509" r="0.24" />
      <circle cx="91.5" cy="6.928203230275509" r="0.24" />
      <circle cx="92.5" cy="6.928203230275509" r="0.24" />
      <circle cx="93.5" cy="6.928203230275509" r="0.24" />
      <circle cx="94.5" cy="6.928203230275509" r="0.24" />
      <circle cx="95.5" cy="6.928203230275509" r="0.24" />
      <circle cx="96.5" cy="6.928203230275509" r="0.24" />
      <circle cx="98.5" cy="6.928203230275509" r="0.24" />
      <circle cx="1" cy="7.794228634059947" r="0.24" />
      <circle cx="2" cy="7.794228634059947" r="0.24" />
      <circle cx="3" cy="7.794228634059947" r="0.24" />
      <circle cx="4" cy="7.794228634059947" r="0.24" />
      <circle cx="5" cy="7.794228634059947" r="0.24" />
      <circle cx="7" cy="7.794228634059947" r="0.24" />
      <circle cx="8" cy="7.794228634059947" r="0.24" />
      <circle cx="9" cy="7.794228634059947" r="0.24" />
      <circle cx="10" cy="7.794228634059947" r="0.24" />
      <circle cx="11" cy="7.794228634059947" r="0.24" />
      <circle cx="12" cy="7.794228634059947" r="0.24" />
      <circle cx="13" cy="7.794228634059947" r="0.24" />
      <circle cx="14" cy="7.794228634059947" r="0.24" />
      <circle cx="15" cy="7.794228634059947" r="0.24" />
      <circle cx="16" cy="7.794228634059947" r="0.24" />
      <circle cx="17" cy="7.794228634059947" r="0.24" />
      <circle cx="18" cy="7.794228634059947" r="0.24" />
      <circle cx="19" cy="7.794228634059947" r="0.24" />
      <circle cx="20" cy="7.794228634059947" r="0.24" />
      <circle cx="21" cy="7.794228634059947" r="0.24" />
      <circle cx="27" cy="7.794228634059947" r="0.24" />
      <circle cx="28" cy="7.794228634059947" r="0.24" />
      <circle cx="52" cy="7.794228634059947" r="0.24" />
      <circle cx="53" cy="7.794228634059947" r="0.24" />
      <circle cx="54" cy="7.794228634059947" r="0.24" />
      <circle cx="58" cy="7.794228634059947" r="0.24" />
      <circle cx="59" cy="7.794228634059947" r="0.24" />
      <circle cx="60" cy="7.794228634059947" r="0.24" />
      <circle cx="61" cy="7.794228634059947" r="0.24" />
      <circle cx="62" cy="7.794228634059947" r="0.24" />
      <circle cx="63" cy="7.794228634059947" r="0.24" />
      <circle cx="64" cy="7.794228634059947" r="0.24" />
      <circle cx="65" cy="7.794228634059947" r="0.24" />
      <circle cx="66" cy="7.794228634059947" r="0.24" />
      <circle cx="67" cy="7.794228634059947" r="0.24" />
      <circle cx="68" cy="7.794228634059947" r="0.24" />
      <circle cx="69" cy="7.794228634059947" r="0.24" />
      <circle cx="70" cy="7.794228634059947" r="0.24" />
      <circle cx="71" cy="7.794228634059947" r="0.24" />
      <circle cx="72" cy="7.794228634059947" r="0.24" />
      <circle cx="73" cy="7.794228634059947" r="0.24" />
      <circle cx="74" cy="7.794228634059947" r="0.24" />
      <circle cx="75" cy="7.794228634059947" r="0.24" />
      <circle cx="76" cy="7.794228634059947" r="0.24" />
      <circle cx="77" cy="7.794228634059947" r="0.24" />
      <circle cx="78" cy="7.794228634059947" r="0.24" />
      <circle cx="79" cy="7.794228634059947" r="0.24" />
      <circle cx="80" cy="7.794228634059947" r="0.24" />
      <circle cx="81" cy="7.794228634059947" r="0.24" />
      <circle cx="82" cy="7.794228634059947" r="0.24" />
      <circle cx="83" cy="7.794228634059947" r="0.24" />
      <circle cx="84" cy="7.794228634059947" r="0.24" />
      <circle cx="85" cy="7.794228634059947" r="0.24" />
      <circle cx="86" cy="7.794228634059947" r="0.24" />
      <circle cx="87" cy="7.794228634059947" r="0.24" />
      <circle cx="88" cy="7.794228634059947" r="0.24" />
      <circle cx="89" cy="7.794228634059947" r="0.24" />
      <circle cx="90" cy="7.794228634059947" r="0.24" />
      <circle cx="91" cy="7.794228634059947" r="0.24" />
      <circle cx="92" cy="7.794228634059947" r="0.24" />
      <circle cx="93" cy="7.794228634059947" r="0.24" />
      <circle cx="94" cy="7.794228634059947" r="0.24" />
      <circle cx="95" cy="7.794228634059947" r="0.24" />
      <circle cx="98" cy="7.794228634059947" r="0.24" />
      <circle cx="3.5" cy="8.660254037844386" r="0.24" />
      <circle cx="9.5" cy="8.660254037844386" r="0.24" />
      <circle cx="10.5" cy="8.660254037844386" r="0.24" />
      <circle cx="11.5" cy="8.660254037844386" r="0.24" />
      <circle cx="12.5" cy="8.660254037844386" r="0.24" />
      <circle cx="13.5" cy="8.660254037844386" r="0.24" />
      <circle cx="14.5" cy="8.660254037844386" r="0.24" />
      <circle cx="15.5" cy="8.660254037844386" r="0.24" />
      <circle cx="16.5" cy="8.660254037844386" r="0.24" />
      <circle cx="17.5" cy="8.660254037844386" r="0.24" />
      <circle cx="18.5" cy="8.660254037844386" r="0.24" />
      <circle cx="19.5" cy="8.660254037844386" r="0.24" />
      <circle cx="20.5" cy="8.660254037844386" r="0.24" />
      <circle cx="21.5" cy="8.660254037844386" r="0.24" />
      <circle cx="26.5" cy="8.660254037844386" r="0.24" />
      <circle cx="27.5" cy="8.660254037844386" r="0.24" />
      <circle cx="28.5" cy="8.660254037844386" r="0.24" />
      <circle cx="30.5" cy="8.660254037844386" r="0.24" />
      <circle cx="51.5" cy="8.660254037844386" r="0.24" />
      <circle cx="53.5" cy="8.660254037844386" r="0.24" />
      <circle cx="54.5" cy="8.660254037844386" r="0.24" />
      <circle cx="56.5" cy="8.660254037844386" r="0.24" />
      <circle cx="57.5" cy="8.660254037844386" r="0.24" />
      <circle cx="58.5" cy="8.660254037844386" r="0.24" />
      <circle cx="59.5" cy="8.660254037844386" r="0.24" />
      <circle cx="60.5" cy="8.660254037844386" r="0.24" />
      <circle cx="61.5" cy="8.660254037844386" r="0.24" />
      <circle cx="62.5" cy="8.660254037844386" r="0.24" />
      <circle cx="63.5" cy="8.660254037844386" r="0.24" />
      <circle cx="64.5" cy="8.660254037844386" r="0.24" />
      <circle cx="65.5" cy="8.660254037844386" r="0.24" />
      <circle cx="66.5" cy="8.660254037844386" r="0.24" />
      <circle cx="67.5" cy="8.660254037844386" r="0.24" />
      <circle cx="68.5" cy="8.660254037844386" r="0.24" />
      <circle cx="69.5" cy="8.660254037844386" r="0.24" />
      <circle cx="70.5" cy="8.660254037844386" r="0.24" />
      <circle cx="71.5" cy="8.660254037844386" r="0.24" />
      <circle cx="72.5" cy="8.660254037844386" r="0.24" />
      <circle cx="73.5" cy="8.660254037844386" r="0.24" />
      <circle cx="74.5" cy="8.660254037844386" r="0.24" />
      <circle cx="75.5" cy="8.660254037844386" r="0.24" />
      <circle cx="76.5" cy="8.660254037844386" r="0.24" />
      <circle cx="77.5" cy="8.660254037844386" r="0.24" />
      <circle cx="78.5" cy="8.660254037844386" r="0.24" />
      <circle cx="79.5" cy="8.660254037844386" r="0.24" />
      <circle cx="80.5" cy="8.660254037844386" r="0.24" />
      <circle cx="81.5" cy="8.660254037844386" r="0.24" />
      <circle cx="82.5" cy="8.660254037844386" r="0.24" />
      <circle cx="83.5" cy="8.660254037844386" r="0.24" />
      <circle cx="84.5" cy="8.660254037844386" r="0.24" />
      <circle cx="85.5" cy="8.660254037844386" r="0.24" />
      <circle cx="86.5" cy="8.660254037844386" r="0.24" />
      <circle cx="87.5" cy="8.660254037844386" r="0.24" />
      <circle cx="88.5" cy="8.660254037844386" r="0.24" />
      <circle cx="89.5" cy="8.660254037844386" r="0.24" />
      <circle cx="90.5" cy="8.660254037844386" r="0.24" />
      <circle cx="96.5" cy="8.660254037844386" r="0.24" />
      <circle cx="3" cy="9.526279441628825" r="0.24" />
      <circle cx="4" cy="9.526279441628825" r="0.24" />
      <circle cx="11" cy="9.526279441628825" r="0.24" />
      <circle cx="12" cy="9.526279441628825" r="0.24" />
      <circle cx="13" cy="9.526279441628825" r="0.24" />
      <circle cx="14" cy="9.526279441628825" r="0.24" />
      <circle cx="15" cy="9.526279441628825" r="0.24" />
      <circle cx="16" cy="9.526279441628825" r="0.24" />
      <circle cx="17" cy="9.526279441628825" r="0.24" />
      <circle cx="18" cy="9.526279441628825" r="0.24" />
      <circle cx="19" cy="9.526279441628825" r="0.24" />
      <circle cx="20" cy="9.526279441628825" r="0.24" />
      <circle cx="21" cy="9.526279441628825" r="0.24" />
      <circle cx="22" cy="9.526279441628825" r="0.24" />
      <circle cx="27" cy="9.526279441628825" r="0.24" />
      <circle cx="28" cy="9.526279441628825" r="0.24" />
      <circle cx="29" cy="9.526279441628825" r="0.24" />
      <circle cx="30" cy="9.526279441628825" r="0.24" />
      <circle cx="31" cy="9.526279441628825" r="0.24" />
      <circle cx="48" cy="9.526279441628825" r="0.24" />
      <circle cx="54" cy="9.526279441628825" r="0.24" />
      <circle cx="55" cy="9.526279441628825" r="0.24" />
      <circle cx="56" cy="9.526279441628825" r="0.24" />
      <circle cx="57" cy="9.526279441628825" r="0.24" />
      <circle cx="58" cy="9.526279441628825" r="0.24" />
      <circle cx="59" cy="9.526279441628825" r="0.24" />
      <circle cx="60" cy="9.526279441628825" r="0.24" />
      <circle cx="61" cy="9.526279441628825" r="0.24" />
      <circle cx="62" cy="9.526279441628825" r="0.24" />
      <circle cx="63" cy="9.526279441628825" r="0.24" />
      <circle cx="64" cy="9.526279441628825" r="0.24" />
      <circle cx="65" cy="9.526279441628825" r="0.24" />
      <circle cx="66" cy="9.526279441628825" r="0.24" />
      <circle cx="67" cy="9.526279441628825" r="0.24" />
      <circle cx="68" cy="9.526279441628825" r="0.24" />
      <circle cx="69" cy="9.526279441628825" r="0.24" />
      <circle cx="70" cy="9.526279441628825" r="0.24" />
      <circle cx="71" cy="9.526279441628825" r="0.24" />
      <circle cx="72" cy="9.526279441628825" r="0.24" />
      <circle cx="73" cy="9.526279441628825" r="0.24" />
      <circle cx="74" cy="9.526279441628825" r="0.24" />
      <circle cx="75" cy="9.526279441628825" r="0.24" />
      <circle cx="76" cy="9.526279441628825" r="0.24" />
      <circle cx="77" cy="9.526279441628825" r="0.24" />
      <circle cx="78" cy="9.526279441628825" r="0.24" />
      <circle cx="79" cy="9.526279441628825" r="0.24" />
      <circle cx="80" cy="9.526279441628825" r="0.24" />
      <circle cx="81" cy="9.526279441628825" r="0.24" />
      <circle cx="82" cy="9.526279441628825" r="0.24" />
      <circle cx="83" cy="9.526279441628825" r="0.24" />
      <circle cx="84" cy="9.526279441628825" r="0.24" />
      <circle cx="85" cy="9.526279441628825" r="0.24" />
      <circle cx="86" cy="9.526279441628825" r="0.24" />
      <circle cx="87" cy="9.526279441628825" r="0.24" />
      <circle cx="88" cy="9.526279441628825" r="0.24" />
      <circle cx="89" cy="9.526279441628825" r="0.24" />
      <circle cx="90" cy="9.526279441628825" r="0.24" />
      <circle cx="96" cy="9.526279441628825" r="0.24" />
      <circle cx="97" cy="9.526279441628825" r="0.24" />
      <circle cx="11.5" cy="10.392304845413264" r="0.24" />
      <circle cx="12.5" cy="10.392304845413264" r="0.24" />
      <circle cx="13.5" cy="10.392304845413264" r="0.24" />
      <circle cx="14.5" cy="10.392304845413264" r="0.24" />
      <circle cx="15.5" cy="10.392304845413264" r="0.24" />
      <circle cx="16.5" cy="10.392304845413264" r="0.24" />
      <circle cx="17.5" cy="10.392304845413264" r="0.24" />
      <circle cx="18.5" cy="10.392304845413264" r="0.24" />
      <circle cx="19.5" cy="10.392304845413264" r="0.24" />
      <circle cx="20.5" cy="10.392304845413264" r="0.24" />
      <circle cx="21.5" cy="10.392304845413264" r="0.24" />
      <circle cx="22.5" cy="10.392304845413264" r="0.24" />
      <circle cx="23.5" cy="10.392304845413264" r="0.24" />
      <circle cx="27.5" cy="10.392304845413264" r="0.24" />
      <circle cx="28.5" cy="10.392304845413264" r="0.24" />
      <circle cx="29.5" cy="10.392304845413264" r="0.24" />
      <circle cx="30.5" cy="10.392304845413264" r="0.24" />
      <circle cx="31.5" cy="10.392304845413264" r="0.24" />
      <circle cx="48.5" cy="10.392304845413264" r="0.24" />
      <circle cx="53.5" cy="10.392304845413264" r="0.24" />
      <circle cx="56.5" cy="10.392304845413264" r="0.24" />
      <circle cx="57.5" cy="10.392304845413264" r="0.24" />
      <circle cx="58.5" cy="10.392304845413264" r="0.24" />
      <circle cx="59.5" cy="10.392304845413264" r="0.24" />
      <circle cx="60.5" cy="10.392304845413264" r="0.24" />
      <circle cx="61.5" cy="10.392304845413264" r="0.24" />
      <circle cx="62.5" cy="10.392304845413264" r="0.24" />
      <circle cx="63.5" cy="10.392304845413264" r="0.24" />
      <circle cx="64.5" cy="10.392304845413264" r="0.24" />
      <circle cx="65.5" cy="10.392304845413264" r="0.24" />
      <circle cx="66.5" cy="10.392304845413264" r="0.24" />
      <circle cx="67.5" cy="10.392304845413264" r="0.24" />
      <circle cx="68.5" cy="10.392304845413264" r="0.24" />
      <circle cx="69.5" cy="10.392304845413264" r="0.24" />
      <circle cx="70.5" cy="10.392304845413264" r="0.24" />
      <circle cx="71.5" cy="10.392304845413264" r="0.24" />
      <circle cx="72.5" cy="10.392304845413264" r="0.24" />
      <circle cx="73.5" cy="10.392304845413264" r="0.24" />
      <circle cx="74.5" cy="10.392304845413264" r="0.24" />
      <circle cx="75.5" cy="10.392304845413264" r="0.24" />
      <circle cx="76.5" cy="10.392304845413264" r="0.24" />
      <circle cx="77.5" cy="10.392304845413264" r="0.24" />
      <circle cx="78.5" cy="10.392304845413264" r="0.24" />
      <circle cx="79.5" cy="10.392304845413264" r="0.24" />
      <circle cx="80.5" cy="10.392304845413264" r="0.24" />
      <circle cx="81.5" cy="10.392304845413264" r="0.24" />
      <circle cx="82.5" cy="10.392304845413264" r="0.24" />
      <circle cx="83.5" cy="10.392304845413264" r="0.24" />
      <circle cx="84.5" cy="10.392304845413264" r="0.24" />
      <circle cx="85.5" cy="10.392304845413264" r="0.24" />
      <circle cx="86.5" cy="10.392304845413264" r="0.24" />
      <circle cx="87.5" cy="10.392304845413264" r="0.24" />
      <circle cx="88.5" cy="10.392304845413264" r="0.24" />
      <circle cx="89.5" cy="10.392304845413264" r="0.24" />
      <circle cx="95.5" cy="10.392304845413264" r="0.24" />
      <circle cx="96.5" cy="10.392304845413264" r="0.24" />
      <circle cx="12" cy="11.258330249197702" r="0.24" />
      <circle cx="13" cy="11.258330249197702" r="0.24" />
      <circle cx="14" cy="11.258330249197702" r="0.24" />
      <circle cx="15" cy="11.258330249197702" r="0.24" />
      <circle cx="16" cy="11.258330249197702" r="0.24" />
      <circle cx="17" cy="11.258330249197702" r="0.24" />
      <circle cx="18" cy="11.258330249197702" r="0.24" />
      <circle cx="19" cy="11.258330249197702" r="0.24" />
      <circle cx="20" cy="11.258330249197702" r="0.24" />
      <circle cx="21" cy="11.258330249197702" r="0.24" />
      <circle cx="22" cy="11.258330249197702" r="0.24" />
      <circle cx="23" cy="11.258330249197702" r="0.24" />
      <circle cx="24" cy="11.258330249197702" r="0.24" />
      <circle cx="25" cy="11.258330249197702" r="0.24" />
      <circle cx="27" cy="11.258330249197702" r="0.24" />
      <circle cx="28" cy="11.258330249197702" r="0.24" />
      <circle cx="29" cy="11.258330249197702" r="0.24" />
      <circle cx="30" cy="11.258330249197702" r="0.24" />
      <circle cx="31" cy="11.258330249197702" r="0.24" />
      <circle cx="32" cy="11.258330249197702" r="0.24" />
      <circle cx="47" cy="11.258330249197702" r="0.24" />
      <circle cx="49" cy="11.258330249197702" r="0.24" />
      <circle cx="53" cy="11.258330249197702" r="0.24" />
      <circle cx="54" cy="11.258330249197702" r="0.24" />
      <circle cx="55" cy="11.258330249197702" r="0.24" />
      <circle cx="56" cy="11.258330249197702" r="0.24" />
      <circle cx="57" cy="11.258330249197702" r="0.24" />
      <circle cx="58" cy="11.258330249197702" r="0.24" />
      <circle cx="59" cy="11.258330249197702" r="0.24" />
      <circle cx="60" cy="11.258330249197702" r="0.24" />
      <circle cx="61" cy="11.258330249197702" r="0.24" />
      <circle cx="62" cy="11.258330249197702" r="0.24" />
      <circle cx="63" cy="11.258330249197702" r="0.24" />
      <circle cx="64" cy="11.258330249197702" r="0.24" />
      <circle cx="65" cy="11.258330249197702" r="0.24" />
      <circle cx="66" cy="11.258330249197702" r="0.24" />
      <circle cx="67" cy="11.258330249197702" r="0.24" />
      <circle cx="68" cy="11.258330249197702" r="0.24" />
      <circle cx="69" cy="11.258330249197702" r="0.24" />
      <circle cx="70" cy="11.258330249197702" r="0.24" />
      <circle cx="71" cy="11.258330249197702" r="0.24" />
      <circle cx="72" cy="11.258330249197702" r="0.24" />
      <circle cx="73" cy="11.258330249197702" r="0.24" />
      <circle cx="74" cy="11.258330249197702" r="0.24" />
      <circle cx="75" cy="11.258330249197702" r="0.24" />
      <circle cx="76" cy="11.258330249197702" r="0.24" />
      <circle cx="77" cy="11.258330249197702" r="0.24" />
      <circle cx="78" cy="11.258330249197702" r="0.24" />
      <circle cx="79" cy="11.258330249197702" r="0.24" />
      <circle cx="80" cy="11.258330249197702" r="0.24" />
      <circle cx="81" cy="11.258330249197702" r="0.24" />
      <circle cx="82" cy="11.258330249197702" r="0.24" />
      <circle cx="83" cy="11.258330249197702" r="0.24" />
      <circle cx="84" cy="11.258330249197702" r="0.24" />
      <circle cx="85" cy="11.258330249197702" r="0.24" />
      <circle cx="86" cy="11.258330249197702" r="0.24" />
      <circle cx="87" cy="11.258330249197702" r="0.24" />
      <circle cx="88" cy="11.258330249197702" r="0.24" />
      <circle cx="89" cy="11.258330249197702" r="0.24" />
      <circle cx="90" cy="11.258330249197702" r="0.24" />
      <circle cx="96" cy="11.258330249197702" r="0.24" />
      <circle cx="12.5" cy="12.12435565298214" r="0.24" />
      <circle cx="13.5" cy="12.12435565298214" r="0.24" />
      <circle cx="14.5" cy="12.12435565298214" r="0.24" />
      <circle cx="15.5" cy="12.12435565298214" r="0.24" />
      <circle cx="16.5" cy="12.12435565298214" r="0.24" />
      <circle cx="17.5" cy="12.12435565298214" r="0.24" />
      <circle cx="18.5" cy="12.12435565298214" r="0.24" />
      <circle cx="19.5" cy="12.12435565298214" r="0.24" />
      <circle cx="20.5" cy="12.12435565298214" r="0.24" />
      <circle cx="21.5" cy="12.12435565298214" r="0.24" />
      <circle cx="22.5" cy="12.12435565298214" r="0.24" />
      <circle cx="23.5" cy="12.12435565298214" r="0.24" />
      <circle cx="24.5" cy="12.12435565298214" r="0.24" />
      <circle cx="25.5" cy="12.12435565298214" r="0.24" />
      <circle cx="26.5" cy="12.12435565298214" r="0.24" />
      <circle cx="27.5" cy="12.12435565298214" r="0.24" />
      <circle cx="28.5" cy="12.12435565298214" r="0.24" />
      <circle cx="29.5" cy="12.12435565298214" r="0.24" />
      <circle cx="30.5" cy="12.12435565298214" r="0.24" />
      <circle cx="31.5" cy="12.12435565298214" r="0.24" />
      <circle cx="32.5" cy="12.12435565298214" r="0.24" />
      <circle cx="48.5" cy="12.12435565298214" r="0.24" />
      <circle cx="49.5" cy="12.12435565298214" r="0.24" />
      <circle cx="51.5" cy="12.12435565298214" r="0.24" />
      <circle cx="52.5" cy="12.12435565298214" r="0.24" />
      <circle cx="53.5" cy="12.12435565298214" r="0.24" />
      <circle cx="54.5" cy="12.12435565298214" r="0.24" />
      <circle cx="55.5" cy="12.12435565298214" r="0.24" />
      <circle cx="56.5" cy="12.12435565298214" r="0.24" />
      <circle cx="57.5" cy="12.12435565298214" r="0.24" />
      <circle cx="58.5" cy="12.12435565298214" r="0.24" />
      <circle cx="59.5" cy="12.12435565298214" r="0.24" />
      <circle cx="60.5" cy="12.12435565298214" r="0.24" />
      <circle cx="61.5" cy="12.12435565298214" r="0.24" />
      <circle cx="62.5" cy="12.12435565298214" r="0.24" />
      <circle cx="63.5" cy="12.12435565298214" r="0.24" />
      <circle cx="64.5" cy="12.12435565298214" r="0.24" />
      <circle cx="65.5" cy="12.12435565298214" r="0.24" />
      <circle cx="66.5" cy="12.12435565298214" r="0.24" />
      <circle cx="67.5" cy="12.12435565298214" r="0.24" />
      <circle cx="68.5" cy="12.12435565298214" r="0.24" />
      <circle cx="69.5" cy="12.12435565298214" r="0.24" />
      <circle cx="70.5" cy="12.12435565298214" r="0.24" />
      <circle cx="71.5" cy="12.12435565298214" r="0.24" />
      <circle cx="72.5" cy="12.12435565298214" r="0.24" />
      <circle cx="73.5" cy="12.12435565298214" r="0.24" />
      <circle cx="74.5" cy="12.12435565298214" r="0.24" />
      <circle cx="75.5" cy="12.12435565298214" r="0.24" />
      <circle cx="76.5" cy="12.12435565298214" r="0.24" />
      <circle cx="77.5" cy="12.12435565298214" r="0.24" />
      <circle cx="78.5" cy="12.12435565298214" r="0.24" />
      <circle cx="79.5" cy="12.12435565298214" r="0.24" />
      <circle cx="80.5" cy="12.12435565298214" r="0.24" />
      <circle cx="81.5" cy="12.12435565298214" r="0.24" />
      <circle cx="82.5" cy="12.12435565298214" r="0.24" />
      <circle cx="83.5" cy="12.12435565298214" r="0.24" />
      <circle cx="84.5" cy="12.12435565298214" r="0.24" />
      <circle cx="85.5" cy="12.12435565298214" r="0.24" />
      <circle cx="86.5" cy="12.12435565298214" r="0.24" />
      <circle cx="87.5" cy="12.12435565298214" r="0.24" />
      <circle cx="88.5" cy="12.12435565298214" r="0.24" />
      <circle cx="89.5" cy="12.12435565298214" r="0.24" />
      <circle cx="90.5" cy="12.12435565298214" r="0.24" />
      <circle cx="91.5" cy="12.12435565298214" r="0.24" />
      <circle cx="12" cy="12.990381056766578" r="0.24" />
      <circle cx="13" cy="12.990381056766578" r="0.24" />
      <circle cx="14" cy="12.990381056766578" r="0.24" />
      <circle cx="15" cy="12.990381056766578" r="0.24" />
      <circle cx="16" cy="12.990381056766578" r="0.24" />
      <circle cx="17" cy="12.990381056766578" r="0.24" />
      <circle cx="18" cy="12.990381056766578" r="0.24" />
      <circle cx="19" cy="12.990381056766578" r="0.24" />
      <circle cx="20" cy="12.990381056766578" r="0.24" />
      <circle cx="21" cy="12.990381056766578" r="0.24" />
      <circle cx="22" cy="12.990381056766578" r="0.24" />
      <circle cx="23" cy="12.990381056766578" r="0.24" />
      <circle cx="24" cy="12.990381056766578" r="0.24" />
      <circle cx="25" cy="12.990381056766578" r="0.24" />
      <circle cx="26" cy="12.990381056766578" r="0.24" />
      <circle cx="27" cy="12.990381056766578" r="0.24" />
      <circle cx="28" cy="12.990381056766578" r="0.24" />
      <circle cx="29" cy="12.990381056766578" r="0.24" />
      <circle cx="31" cy="12.990381056766578" r="0.24" />
      <circle cx="48" cy="12.990381056766578" r="0.24" />
      <circle cx="50" cy="12.990381056766578" r="0.24" />
      <circle cx="51" cy="12.990381056766578" r="0.24" />
      <circle cx="52" cy="12.990381056766578" r="0.24" />
      <circle cx="53" cy="12.990381056766578" r="0.24" />
      <circle cx="54" cy="12.990381056766578" r="0.24" />
      <circle cx="55" cy="12.990381056766578" r="0.24" />
      <circle cx="56" cy="12.990381056766578" r="0.24" />
      <circle cx="57" cy="12.990381056766578" r="0.24" />
      <circle cx="58" cy="12.990381056766578" r="0.24" />
      <circle cx="59" cy="12.990381056766578" r="0.24" />
      <circle cx="60" cy="12.990381056766578" r="0.24" />
      <circle cx="61" cy="12.990381056766578" r="0.24" />
      <circle cx="62" cy="12.990381056766578" r="0.24" />
      <circle cx="63" cy="12.990381056766578" r="0.24" />
      <circle cx="64" cy="12.990381056766578" r="0.24" />
      <circle cx="65" cy="12.990381056766578" r="0.24" />
      <circle cx="66" cy="12.990381056766578" r="0.24" />
      <circle cx="67" cy="12.990381056766578" r="0.24" />
      <circle cx="68" cy="12.990381056766578" r="0.24" />
      <circle cx="69" cy="12.990381056766578" r="0.24" />
      <circle cx="70" cy="12.990381056766578" r="0.24" />
      <circle cx="71" cy="12.990381056766578" r="0.24" />
      <circle cx="72" cy="12.990381056766578" r="0.24" />
      <circle cx="73" cy="12.990381056766578" r="0.24" />
      <circle cx="74" cy="12.990381056766578" r="0.24" />
      <circle cx="75" cy="12.990381056766578" r="0.24" />
      <circle cx="76" cy="12.990381056766578" r="0.24" />
      <circle cx="77" cy="12.990381056766578" r="0.24" />
      <circle cx="78" cy="12.990381056766578" r="0.24" />
      <circle cx="79" cy="12.990381056766578" r="0.24" />
      <circle cx="80" cy="12.990381056766578" r="0.24" />
      <circle cx="81" cy="12.990381056766578" r="0.24" />
      <circle cx="82" cy="12.990381056766578" r="0.24" />
      <circle cx="83" cy="12.990381056766578" r="0.24" />
      <circle cx="84" cy="12.990381056766578" r="0.24" />
      <circle cx="85" cy="12.990381056766578" r="0.24" />
      <circle cx="86" cy="12.990381056766578" r="0.24" />
      <circle cx="87" cy="12.990381056766578" r="0.24" />
      <circle cx="88" cy="12.990381056766578" r="0.24" />
      <circle cx="89" cy="12.990381056766578" r="0.24" />
      <circle cx="90" cy="12.990381056766578" r="0.24" />
      <circle cx="13.5" cy="13.856406460551018" r="0.24" />
      <circle cx="14.5" cy="13.856406460551018" r="0.24" />
      <circle cx="15.5" cy="13.856406460551018" r="0.24" />
      <circle cx="16.5" cy="13.856406460551018" r="0.24" />
      <circle cx="17.5" cy="13.856406460551018" r="0.24" />
      <circle cx="18.5" cy="13.856406460551018" r="0.24" />
      <circle cx="19.5" cy="13.856406460551018" r="0.24" />
      <circle cx="20.5" cy="13.856406460551018" r="0.24" />
      <circle cx="21.5" cy="13.856406460551018" r="0.24" />
      <circle cx="22.5" cy="13.856406460551018" r="0.24" />
      <circle cx="23.5" cy="13.856406460551018" r="0.24" />
      <circle cx="24.5" cy="13.856406460551018" r="0.24" />
      <circle cx="25.5" cy="13.856406460551018" r="0.24" />
      <circle cx="26.5" cy="13.856406460551018" r="0.24" />
      <circle cx="27.5" cy="13.856406460551018" r="0.24" />
      <circle cx="28.5" cy="13.856406460551018" r="0.24" />
      <circle cx="29.5" cy="13.856406460551018" r="0.24" />
      <circle cx="32.5" cy="13.856406460551018" r="0.24" />
      <circle cx="33.5" cy="13.856406460551018" r="0.24" />
      <circle cx="48.5" cy="13.856406460551018" r="0.24" />
      <circle cx="49.5" cy="13.856406460551018" r="0.24" />
      <circle cx="50.5" cy="13.856406460551018" r="0.24" />
      <circle cx="51.5" cy="13.856406460551018" r="0.24" />
      <circle cx="52.5" cy="13.856406460551018" r="0.24" />
      <circle cx="53.5" cy="13.856406460551018" r="0.24" />
      <circle cx="54.5" cy="13.856406460551018" r="0.24" />
      <circle cx="55.5" cy="13.856406460551018" r="0.24" />
      <circle cx="56.5" cy="13.856406460551018" r="0.24" />
      <circle cx="57.5" cy="13.856406460551018" r="0.24" />
      <circle cx="58.5" cy="13.856406460551018" r="0.24" />
      <circle cx="59.5" cy="13.856406460551018" r="0.24" />
      <circle cx="60.5" cy="13.856406460551018" r="0.24" />
      <circle cx="61.5" cy="13.856406460551018" r="0.24" />
      <circle cx="62.5" cy="13.856406460551018" r="0.24" />
      <circle cx="63.5" cy="13.856406460551018" r="0.24" />
      <circle cx="64.5" cy="13.856406460551018" r="0.24" />
      <circle cx="65.5" cy="13.856406460551018" r="0.24" />
      <circle cx="66.5" cy="13.856406460551018" r="0.24" />
      <circle cx="67.5" cy="13.856406460551018" r="0.24" />
      <circle cx="68.5" cy="13.856406460551018" r="0.24" />
      <circle cx="69.5" cy="13.856406460551018" r="0.24" />
      <circle cx="70.5" cy="13.856406460551018" r="0.24" />
      <circle cx="71.5" cy="13.856406460551018" r="0.24" />
      <circle cx="72.5" cy="13.856406460551018" r="0.24" />
      <circle cx="73.5" cy="13.856406460551018" r="0.24" />
      <circle cx="74.5" cy="13.856406460551018" r="0.24" />
      <circle cx="75.5" cy="13.856406460551018" r="0.24" />
      <circle cx="76.5" cy="13.856406460551018" r="0.24" />
      <circle cx="77.5" cy="13.856406460551018" r="0.24" />
      <circle cx="78.5" cy="13.856406460551018" r="0.24" />
      <circle cx="79.5" cy="13.856406460551018" r="0.24" />
      <circle cx="80.5" cy="13.856406460551018" r="0.24" />
      <circle cx="81.5" cy="13.856406460551018" r="0.24" />
      <circle cx="82.5" cy="13.856406460551018" r="0.24" />
      <circle cx="83.5" cy="13.856406460551018" r="0.24" />
      <circle cx="84.5" cy="13.856406460551018" r="0.24" />
      <circle cx="85.5" cy="13.856406460551018" r="0.24" />
      <circle cx="86.5" cy="13.856406460551018" r="0.24" />
      <circle cx="87.5" cy="13.856406460551018" r="0.24" />
      <circle cx="88.5" cy="13.856406460551018" r="0.24" />
      <circle cx="89.5" cy="13.856406460551018" r="0.24" />
      <circle cx="90.5" cy="13.856406460551018" r="0.24" />
      <circle cx="91.5" cy="13.856406460551018" r="0.24" />
      <circle cx="13" cy="14.722431864335457" r="0.24" />
      <circle cx="14" cy="14.722431864335457" r="0.24" />
      <circle cx="15" cy="14.722431864335457" r="0.24" />
      <circle cx="16" cy="14.722431864335457" r="0.24" />
      <circle cx="17" cy="14.722431864335457" r="0.24" />
      <circle cx="18" cy="14.722431864335457" r="0.24" />
      <circle cx="19" cy="14.722431864335457" r="0.24" />
      <circle cx="20" cy="14.722431864335457" r="0.24" />
      <circle cx="21" cy="14.722431864335457" r="0.24" />
      <circle cx="22" cy="14.722431864335457" r="0.24" />
      <circle cx="23" cy="14.722431864335457" r="0.24" />
      <circle cx="24" cy="14.722431864335457" r="0.24" />
      <circle cx="25" cy="14.722431864335457" r="0.24" />
      <circle cx="26" cy="14.722431864335457" r="0.24" />
      <circle cx="27" cy="14.722431864335457" r="0.24" />
      <circle cx="28" cy="14.722431864335457" r="0.24" />
      <circle cx="29" cy="14.722431864335457" r="0.24" />
      <circle cx="30" cy="14.722431864335457" r="0.24" />
      <circle cx="31" cy="14.722431864335457" r="0.24" />
      <circle cx="50" cy="14.722431864335457" r="0.24" />
      <circle cx="51" cy="14.722431864335457" r="0.24" />
      <circle cx="52" cy="14.722431864335457" r="0.24" />
      <circle cx="53" cy="14.722431864335457" r="0.24" />
      <circle cx="54" cy="14.722431864335457" r="0.24" />
      <circle cx="55" cy="14.722431864335457" r="0.24" />
      <circle cx="56" cy="14.722431864335457" r="0.24" />
      <circle cx="57" cy="14.722431864335457" r="0.24" />
      <circle cx="58" cy="14.722431864335457" r="0.24" />
      <circle cx="59" cy="14.722431864335457" r="0.24" />
      <circle cx="61" cy="14.722431864335457" r="0.24" />
      <circle cx="62" cy="14.722431864335457" r="0.24" />
      <circle cx="63" cy="14.722431864335457" r="0.24" />
      <circle cx="66" cy="14.722431864335457" r="0.24" />
      <circle cx="67" cy="14.722431864335457" r="0.24" />
      <circle cx="68" cy="14.722431864335457" r="0.24" />
      <circle cx="69" cy="14.722431864335457" r="0.24" />
      <circle cx="70" cy="14.722431864335457" r="0.24" />
      <circle cx="71" cy="14.722431864335457" r="0.24" />
      <circle cx="72" cy="14.722431864335457" r="0.24" />
      <circle cx="73" cy="14.722431864335457" r="0.24" />
      <circle cx="74" cy="14.722431864335457" r="0.24" />
      <circle cx="75" cy="14.722431864335457" r="0.24" />
      <circle cx="76" cy="14.722431864335457" r="0.24" />
      <circle cx="77" cy="14.722431864335457" r="0.24" />
      <circle cx="78" cy="14.722431864335457" r="0.24" />
      <circle cx="79" cy="14.722431864335457" r="0.24" />
      <circle cx="80" cy="14.722431864335457" r="0.24" />
      <circle cx="81" cy="14.722431864335457" r="0.24" />
      <circle cx="82" cy="14.722431864335457" r="0.24" />
      <circle cx="83" cy="14.722431864335457" r="0.24" />
      <circle cx="84" cy="14.722431864335457" r="0.24" />
      <circle cx="85" cy="14.722431864335457" r="0.24" />
      <circle cx="86" cy="14.722431864335457" r="0.24" />
      <circle cx="87" cy="14.722431864335457" r="0.24" />
      <circle cx="88" cy="14.722431864335457" r="0.24" />
      <circle cx="89" cy="14.722431864335457" r="0.24" />
      <circle cx="90" cy="14.722431864335457" r="0.24" />
      <circle cx="13.5" cy="15.588457268119894" r="0.24" />
      <circle cx="14.5" cy="15.588457268119894" r="0.24" />
      <circle cx="15.5" cy="15.588457268119894" r="0.24" />
      <circle cx="16.5" cy="15.588457268119894" r="0.24" />
      <circle cx="17.5" cy="15.588457268119894" r="0.24" />
      <circle cx="18.5" cy="15.588457268119894" r="0.24" />
      <circle cx="19.5" cy="15.588457268119894" r="0.24" />
      <circle cx="20.5" cy="15.588457268119894" r="0.24" />
      <circle cx="21.5" cy="15.588457268119894" r="0.24" />
      <circle cx="22.5" cy="15.588457268119894" r="0.24" />
      <circle cx="23.5" cy="15.588457268119894" r="0.24" />
      <circle cx="24.5" cy="15.588457268119894" r="0.24" />
      <circle cx="25.5" cy="15.588457268119894" r="0.24" />
      <circle cx="26.5" cy="15.588457268119894" r="0.24" />
      <circle cx="27.5" cy="15.588457268119894" r="0.24" />
      <circle cx="28.5" cy="15.588457268119894" r="0.24" />
      <circle cx="30.5" cy="15.588457268119894" r="0.24" />
      <circle cx="49.5" cy="15.588457268119894" r="0.24" />
      <circle cx="50.5" cy="15.588457268119894" r="0.24" />
      <circle cx="51.5" cy="15.588457268119894" r="0.24" />
      <circle cx="52.5" cy="15.588457268119894" r="0.24" />
      <circle cx="54.5" cy="15.588457268119894" r="0.24" />
      <circle cx="55.5" cy="15.588457268119894" r="0.24" />
      <circle cx="56.5" cy="15.588457268119894" r="0.24" />
      <circle cx="57.5" cy="15.588457268119894" r="0.24" />
      <circle cx="61.5" cy="15.588457268119894" r="0.24" />
      <circle cx="62.5" cy="15.588457268119894" r="0.24" />
      <circle cx="64.5" cy="15.588457268119894" r="0.24" />
      <circle cx="65.5" cy="15.588457268119894" r="0.24" />
      <circle cx="66.5" cy="15.588457268119894" r="0.24" />
      <circle cx="67.5" cy="15.588457268119894" r="0.24" />
      <circle cx="68.5" cy="15.588457268119894" r="0.24" />
      <circle cx="69.5" cy="15.588457268119894" r="0.24" />
      <circle cx="70.5" cy="15.588457268119894" r="0.24" />
      <circle cx="71.5" cy="15.588457268119894" r="0.24" />
      <circle cx="72.5" cy="15.588457268119894" r="0.24" />
      <circle cx="73.5" cy="15.588457268119894" r="0.24" />
      <circle cx="74.5" cy="15.588457268119894" r="0.24" />
      <circle cx="75.5" cy="15.588457268119894" r="0.24" />
      <circle cx="76.5" cy="15.588457268119894" r="0.24" />
      <circle cx="77.5" cy="15.588457268119894" r="0.24" />
      <circle cx="78.5" cy="15.588457268119894" r="0.24" />
      <circle cx="79.5" cy="15.588457268119894" r="0.24" />
      <circle cx="80.5" cy="15.588457268119894" r="0.24" />
      <circle cx="81.5" cy="15.588457268119894" r="0.24" />
      <circle cx="82.5" cy="15.588457268119894" r="0.24" />
      <circle cx="83.5" cy="15.588457268119894" r="0.24" />
      <circle cx="84.5" cy="15.588457268119894" r="0.24" />
      <circle cx="85.5" cy="15.588457268119894" r="0.24" />
      <circle cx="86.5" cy="15.588457268119894" r="0.24" />
      <circle cx="87.5" cy="15.588457268119894" r="0.24" />
      <circle cx="88.5" cy="15.588457268119894" r="0.24" />
      <circle cx="89.5" cy="15.588457268119894" r="0.24" />
      <circle cx="91.5" cy="15.588457268119894" r="0.24" />
      <circle cx="13" cy="16.454482671904334" r="0.24" />
      <circle cx="14" cy="16.454482671904334" r="0.24" />
      <circle cx="15" cy="16.454482671904334" r="0.24" />
      <circle cx="16" cy="16.454482671904334" r="0.24" />
      <circle cx="17" cy="16.454482671904334" r="0.24" />
      <circle cx="18" cy="16.454482671904334" r="0.24" />
      <circle cx="19" cy="16.454482671904334" r="0.24" />
      <circle cx="20" cy="16.454482671904334" r="0.24" />
      <circle cx="21" cy="16.454482671904334" r="0.24" />
      <circle cx="22" cy="16.454482671904334" r="0.24" />
      <circle cx="23" cy="16.454482671904334" r="0.24" />
      <circle cx="24" cy="16.454482671904334" r="0.24" />
      <circle cx="25" cy="16.454482671904334" r="0.24" />
      <circle cx="26" cy="16.454482671904334" r="0.24" />
      <circle cx="27" cy="16.454482671904334" r="0.24" />
      <circle cx="28" cy="16.454482671904334" r="0.24" />
      <circle cx="47" cy="16.454482671904334" r="0.24" />
      <circle cx="48" cy="16.454482671904334" r="0.24" />
      <circle cx="49" cy="16.454482671904334" r="0.24" />
      <circle cx="50" cy="16.454482671904334" r="0.24" />
      <circle cx="53" cy="16.454482671904334" r="0.24" />
      <circle cx="56" cy="16.454482671904334" r="0.24" />
      <circle cx="57" cy="16.454482671904334" r="0.24" />
      <circle cx="62" cy="16.454482671904334" r="0.24" />
      <circle cx="63" cy="16.454482671904334" r="0.24" />
      <circle cx="65" cy="16.454482671904334" r="0.24" />
      <circle cx="66" cy="16.454482671904334" r="0.24" />
      <circle cx="67" cy="16.454482671904334" r="0.24" />
      <circle cx="68" cy="16.454482671904334" r="0.24" />
      <circle cx="69" cy="16.454482671904334" r="0.24" />
      <circle cx="70" cy="16.454482671904334" r="0.24" />
      <circle cx="71" cy="16.454482671904334" r="0.24" />
      <circle cx="72" cy="16.454482671904334" r="0.24" />
      <circle cx="73" cy="16.454482671904334" r="0.24" />
      <circle cx="74" cy="16.454482671904334" r="0.24" />
      <circle cx="75" cy="16.454482671904334" r="0.24" />
      <circle cx="76" cy="16.454482671904334" r="0.24" />
      <circle cx="77" cy="16.454482671904334" r="0.24" />
      <circle cx="78" cy="16.454482671904334" r="0.24" />
      <circle cx="79" cy="16.454482671904334" r="0.24" />
      <circle cx="80" cy="16.454482671904334" r="0.24" />
      <circle cx="81" cy="16.454482671904334" r="0.24" />
      <circle cx="82" cy="16.454482671904334" r="0.24" />
      <circle cx="83" cy="16.454482671904334" r="0.24" />
      <circle cx="84" cy="16.454482671904334" r="0.24" />
      <circle cx="85" cy="16.454482671904334" r="0.24" />
      <circle cx="86" cy="16.454482671904334" r="0.24" />
      <circle cx="87" cy="16.454482671904334" r="0.24" />
      <circle cx="91" cy="16.454482671904334" r="0.24" />
      <circle cx="13.5" cy="17.32050807568877" r="0.24" />
      <circle cx="14.5" cy="17.32050807568877" r="0.24" />
      <circle cx="15.5" cy="17.32050807568877" r="0.24" />
      <circle cx="16.5" cy="17.32050807568877" r="0.24" />
      <circle cx="17.5" cy="17.32050807568877" r="0.24" />
      <circle cx="18.5" cy="17.32050807568877" r="0.24" />
      <circle cx="19.5" cy="17.32050807568877" r="0.24" />
      <circle cx="20.5" cy="17.32050807568877" r="0.24" />
      <circle cx="21.5" cy="17.32050807568877" r="0.24" />
      <circle cx="22.5" cy="17.32050807568877" r="0.24" />
      <circle cx="23.5" cy="17.32050807568877" r="0.24" />
      <circle cx="24.5" cy="17.32050807568877" r="0.24" />
      <circle cx="25.5" cy="17.32050807568877" r="0.24" />
      <circle cx="26.5" cy="17.32050807568877" r="0.24" />
      <circle cx="27.5" cy="17.32050807568877" r="0.24" />
      <circle cx="47.5" cy="17.32050807568877" r="0.24" />
      <circle cx="48.5" cy="17.32050807568877" r="0.24" />
      <circle cx="55.5" cy="17.32050807568877" r="0.24" />
      <circle cx="57.5" cy="17.32050807568877" r="0.24" />
      <circle cx="58.5" cy="17.32050807568877" r="0.24" />
      <circle cx="59.5" cy="17.32050807568877" r="0.24" />
      <circle cx="60.5" cy="17.32050807568877" r="0.24" />
      <circle cx="61.5" cy="17.32050807568877" r="0.24" />
      <circle cx="62.5" cy="17.32050807568877" r="0.24" />
      <circle cx="63.5" cy="17.32050807568877" r="0.24" />
      <circle cx="65.5" cy="17.32050807568877" r="0.24" />
      <circle cx="66.5" cy="17.32050807568877" r="0.24" />
      <circle cx="67.5" cy="17.32050807568877" r="0.24" />
      <circle cx="68.5" cy="17.32050807568877" r="0.24" />
      <circle cx="69.5" cy="17.32050807568877" r="0.24" />
      <circle cx="70.5" cy="17.32050807568877" r="0.24" />
      <circle cx="71.5" cy="17.32050807568877" r="0.24" />
      <circle cx="72.5" cy="17.32050807568877" r="0.24" />
      <circle cx="73.5" cy="17.32050807568877" r="0.24" />
      <circle cx="74.5" cy="17.32050807568877" r="0.24" />
      <circle cx="75.5" cy="17.32050807568877" r="0.24" />
      <circle cx="76.5" cy="17.32050807568877" r="0.24" />
      <circle cx="77.5" cy="17.32050807568877" r="0.24" />
      <circle cx="78.5" cy="17.32050807568877" r="0.24" />
      <circle cx="79.5" cy="17.32050807568877" r="0.24" />
      <circle cx="80.5" cy="17.32050807568877" r="0.24" />
      <circle cx="81.5" cy="17.32050807568877" r="0.24" />
      <circle cx="82.5" cy="17.32050807568877" r="0.24" />
      <circle cx="83.5" cy="17.32050807568877" r="0.24" />
      <circle cx="84.5" cy="17.32050807568877" r="0.24" />
      <circle cx="85.5" cy="17.32050807568877" r="0.24" />
      <circle cx="86.5" cy="17.32050807568877" r="0.24" />
      <circle cx="14" cy="18.186533479473212" r="0.24" />
      <circle cx="15" cy="18.186533479473212" r="0.24" />
      <circle cx="16" cy="18.186533479473212" r="0.24" />
      <circle cx="17" cy="18.186533479473212" r="0.24" />
      <circle cx="18" cy="18.186533479473212" r="0.24" />
      <circle cx="19" cy="18.186533479473212" r="0.24" />
      <circle cx="20" cy="18.186533479473212" r="0.24" />
      <circle cx="21" cy="18.186533479473212" r="0.24" />
      <circle cx="22" cy="18.186533479473212" r="0.24" />
      <circle cx="23" cy="18.186533479473212" r="0.24" />
      <circle cx="24" cy="18.186533479473212" r="0.24" />
      <circle cx="25" cy="18.186533479473212" r="0.24" />
      <circle cx="26" cy="18.186533479473212" r="0.24" />
      <circle cx="27" cy="18.186533479473212" r="0.24" />
      <circle cx="47" cy="18.186533479473212" r="0.24" />
      <circle cx="48" cy="18.186533479473212" r="0.24" />
      <circle cx="49" cy="18.186533479473212" r="0.24" />
      <circle cx="56" cy="18.186533479473212" r="0.24" />
      <circle cx="58" cy="18.186533479473212" r="0.24" />
      <circle cx="59" cy="18.186533479473212" r="0.24" />
      <circle cx="60" cy="18.186533479473212" r="0.24" />
      <circle cx="61" cy="18.186533479473212" r="0.24" />
      <circle cx="62" cy="18.186533479473212" r="0.24" />
      <circle cx="63" cy="18.186533479473212" r="0.24" />
      <circle cx="64" cy="18.186533479473212" r="0.24" />
      <circle cx="66" cy="18.186533479473212" r="0.24" />
      <circle cx="67" cy="18.186533479473212" r="0.24" />
      <circle cx="68" cy="18.186533479473212" r="0.24" />
      <circle cx="69" cy="18.186533479473212" r="0.24" />
      <circle cx="70" cy="18.186533479473212" r="0.24" />
      <circle cx="71" cy="18.186533479473212" r="0.24" />
      <circle cx="72" cy="18.186533479473212" r="0.24" />
      <circle cx="73" cy="18.186533479473212" r="0.24" />
      <circle cx="74" cy="18.186533479473212" r="0.24" />
      <circle cx="75" cy="18.186533479473212" r="0.24" />
      <circle cx="76" cy="18.186533479473212" r="0.24" />
      <circle cx="77" cy="18.186533479473212" r="0.24" />
      <circle cx="78" cy="18.186533479473212" r="0.24" />
      <circle cx="79" cy="18.186533479473212" r="0.24" />
      <circle cx="80" cy="18.186533479473212" r="0.24" />
      <circle cx="81" cy="18.186533479473212" r="0.24" />
      <circle cx="82" cy="18.186533479473212" r="0.24" />
      <circle cx="83" cy="18.186533479473212" r="0.24" />
      <circle cx="84" cy="18.186533479473212" r="0.24" />
      <circle cx="85" cy="18.186533479473212" r="0.24" />
      <circle cx="87" cy="18.186533479473212" r="0.24" />
      <circle cx="91" cy="18.186533479473212" r="0.24" />
      <circle cx="14.5" cy="19.05255888325765" r="0.24" />
      <circle cx="15.5" cy="19.05255888325765" r="0.24" />
      <circle cx="16.5" cy="19.05255888325765" r="0.24" />
      <circle cx="17.5" cy="19.05255888325765" r="0.24" />
      <circle cx="18.5" cy="19.05255888325765" r="0.24" />
      <circle cx="19.5" cy="19.05255888325765" r="0.24" />
      <circle cx="20.5" cy="19.05255888325765" r="0.24" />
      <circle cx="21.5" cy="19.05255888325765" r="0.24" />
      <circle cx="22.5" cy="19.05255888325765" r="0.24" />
      <circle cx="23.5" cy="19.05255888325765" r="0.24" />
      <circle cx="24.5" cy="19.05255888325765" r="0.24" />
      <circle cx="25.5" cy="19.05255888325765" r="0.24" />
      <circle cx="26.5" cy="19.05255888325765" r="0.24" />
      <circle cx="48.5" cy="19.05255888325765" r="0.24" />
      <circle cx="49.5" cy="19.05255888325765" r="0.24" />
      <circle cx="50.5" cy="19.05255888325765" r="0.24" />
      <circle cx="51.5" cy="19.05255888325765" r="0.24" />
      <circle cx="52.5" cy="19.05255888325765" r="0.24" />
      <circle cx="60.5" cy="19.05255888325765" r="0.24" />
      <circle cx="61.5" cy="19.05255888325765" r="0.24" />
      <circle cx="62.5" cy="19.05255888325765" r="0.24" />
      <circle cx="63.5" cy="19.05255888325765" r="0.24" />
      <circle cx="64.5" cy="19.05255888325765" r="0.24" />
      <circle cx="65.5" cy="19.05255888325765" r="0.24" />
      <circle cx="66.5" cy="19.05255888325765" r="0.24" />
      <circle cx="67.5" cy="19.05255888325765" r="0.24" />
      <circle cx="68.5" cy="19.05255888325765" r="0.24" />
      <circle cx="69.5" cy="19.05255888325765" r="0.24" />
      <circle cx="70.5" cy="19.05255888325765" r="0.24" />
      <circle cx="71.5" cy="19.05255888325765" r="0.24" />
      <circle cx="72.5" cy="19.05255888325765" r="0.24" />
      <circle cx="73.5" cy="19.05255888325765" r="0.24" />
      <circle cx="74.5" cy="19.05255888325765" r="0.24" />
      <circle cx="75.5" cy="19.05255888325765" r="0.24" />
      <circle cx="76.5" cy="19.05255888325765" r="0.24" />
      <circle cx="77.5" cy="19.05255888325765" r="0.24" />
      <circle cx="78.5" cy="19.05255888325765" r="0.24" />
      <circle cx="79.5" cy="19.05255888325765" r="0.24" />
      <circle cx="80.5" cy="19.05255888325765" r="0.24" />
      <circle cx="81.5" cy="19.05255888325765" r="0.24" />
      <circle cx="82.5" cy="19.05255888325765" r="0.24" />
      <circle cx="83.5" cy="19.05255888325765" r="0.24" />
      <circle cx="84.5" cy="19.05255888325765" r="0.24" />
      <circle cx="87.5" cy="19.05255888325765" r="0.24" />
      <circle cx="88.5" cy="19.05255888325765" r="0.24" />
      <circle cx="89.5" cy="19.05255888325765" r="0.24" />
      <circle cx="90.5" cy="19.05255888325765" r="0.24" />
      <circle cx="15" cy="19.918584287042087" r="0.24" />
      <circle cx="16" cy="19.918584287042087" r="0.24" />
      <circle cx="17" cy="19.918584287042087" r="0.24" />
      <circle cx="18" cy="19.918584287042087" r="0.24" />
      <circle cx="19" cy="19.918584287042087" r="0.24" />
      <circle cx="20" cy="19.918584287042087" r="0.24" />
      <circle cx="21" cy="19.918584287042087" r="0.24" />
      <circle cx="22" cy="19.918584287042087" r="0.24" />
      <circle cx="23" cy="19.918584287042087" r="0.24" />
      <circle cx="24" cy="19.918584287042087" r="0.24" />
      <circle cx="25" cy="19.918584287042087" r="0.24" />
      <circle cx="47" cy="19.918584287042087" r="0.24" />
      <circle cx="48" cy="19.918584287042087" r="0.24" />
      <circle cx="49" cy="19.918584287042087" r="0.24" />
      <circle cx="50" cy="19.918584287042087" r="0.24" />
      <circle cx="51" cy="19.918584287042087" r="0.24" />
      <circle cx="52" cy="19.918584287042087" r="0.24" />
      <circle cx="53" cy="19.918584287042087" r="0.24" />
      <circle cx="56" cy="19.918584287042087" r="0.24" />
      <circle cx="60" cy="19.918584287042087" r="0.24" />
      <circle cx="61" cy="19.918584287042087" r="0.24" />
      <circle cx="62" cy="19.918584287042087" r="0.24" />
      <circle cx="63" cy="19.918584287042087" r="0.24" />
      <circle cx="64" cy="19.918584287042087" r="0.24" />
      <circle cx="65" cy="19.918584287042087" r="0.24" />
      <circle cx="66" cy="19.918584287042087" r="0.24" />
      <circle cx="67" cy="19.918584287042087" r="0.24" />
      <circle cx="68" cy="19.918584287042087" r="0.24" />
      <circle cx="69" cy="19.918584287042087" r="0.24" />
      <circle cx="70" cy="19.918584287042087" r="0.24" />
      <circle cx="71" cy="19.918584287042087" r="0.24" />
      <circle cx="72" cy="19.918584287042087" r="0.24" />
      <circle cx="73" cy="19.918584287042087" r="0.24" />
      <circle cx="74" cy="19.918584287042087" r="0.24" />
      <circle cx="75" cy="19.918584287042087" r="0.24" />
      <circle cx="76" cy="19.918584287042087" r="0.24" />
      <circle cx="77" cy="19.918584287042087" r="0.24" />
      <circle cx="78" cy="19.918584287042087" r="0.24" />
      <circle cx="79" cy="19.918584287042087" r="0.24" />
      <circle cx="80" cy="19.918584287042087" r="0.24" />
      <circle cx="81" cy="19.918584287042087" r="0.24" />
      <circle cx="82" cy="19.918584287042087" r="0.24" />
      <circle cx="83" cy="19.918584287042087" r="0.24" />
      <circle cx="84" cy="19.918584287042087" r="0.24" />
      <circle cx="85" cy="19.918584287042087" r="0.24" />
      <circle cx="88" cy="19.918584287042087" r="0.24" />
      <circle cx="15.5" cy="20.784609690826528" r="0.24" />
      <circle cx="16.5" cy="20.784609690826528" r="0.24" />
      <circle cx="17.5" cy="20.784609690826528" r="0.24" />
      <circle cx="18.5" cy="20.784609690826528" r="0.24" />
      <circle cx="19.5" cy="20.784609690826528" r="0.24" />
      <circle cx="20.5" cy="20.784609690826528" r="0.24" />
      <circle cx="21.5" cy="20.784609690826528" r="0.24" />
      <circle cx="22.5" cy="20.784609690826528" r="0.24" />
      <circle cx="24.5" cy="20.784609690826528" r="0.24" />
      <circle cx="25.5" cy="20.784609690826528" r="0.24" />
      <circle cx="47.5" cy="20.784609690826528" r="0.24" />
      <circle cx="48.5" cy="20.784609690826528" r="0.24" />
      <circle cx="49.5" cy="20.784609690826528" r="0.24" />
      <circle cx="50.5" cy="20.784609690826528" r="0.24" />
      <circle cx="51.5" cy="20.784609690826528" r="0.24" />
      <circle cx="52.5" cy="20.784609690826528" r="0.24" />
      <circle cx="53.5" cy="20.784609690826528" r="0.24" />
      <circle cx="54.5" cy="20.784609690826528" r="0.24" />
      <circle cx="55.5" cy="20.784609690826528" r="0.24" />
      <circle cx="56.5" cy="20.784609690826528" r="0.24" />
      <circle cx="57.5" cy="20.784609690826528" r="0.24" />
      <circle cx="58.5" cy="20.784609690826528" r="0.24" />
      <circle cx="59.5" cy="20.784609690826528" r="0.24" />
      <circle cx="60.5" cy="20.784609690826528" r="0.24" />
      <circle cx="61.5" cy="20.784609690826528" r="0.24" />
      <circle cx="62.5" cy="20.784609690826528" r="0.24" />
      <circle cx="63.5" cy="20.784609690826528" r="0.24" />
      <circle cx="64.5" cy="20.784609690826528" r="0.24" />
      <circle cx="65.5" cy="20.784609690826528" r="0.24" />
      <circle cx="66.5" cy="20.784609690826528" r="0.24" />
      <circle cx="67.5" cy="20.784609690826528" r="0.24" />
      <circle cx="68.5" cy="20.784609690826528" r="0.24" />
      <circle cx="69.5" cy="20.784609690826528" r="0.24" />
      <circle cx="70.5" cy="20.784609690826528" r="0.24" />
      <circle cx="71.5" cy="20.784609690826528" r="0.24" />
      <circle cx="72.5" cy="20.784609690826528" r="0.24" />
      <circle cx="73.5" cy="20.784609690826528" r="0.24" />
      <circle cx="74.5" cy="20.784609690826528" r="0.24" />
      <circle cx="75.5" cy="20.784609690826528" r="0.24" />
      <circle cx="76.5" cy="20.784609690826528" r="0.24" />
      <circle cx="77.5" cy="20.784609690826528" r="0.24" />
      <circle cx="78.5" cy="20.784609690826528" r="0.24" />
      <circle cx="79.5" cy="20.784609690826528" r="0.24" />
      <circle cx="80.5" cy="20.784609690826528" r="0.24" />
      <circle cx="81.5" cy="20.784609690826528" r="0.24" />
      <circle cx="82.5" cy="20.784609690826528" r="0.24" />
      <circle cx="83.5" cy="20.784609690826528" r="0.24" />
      <circle cx="84.5" cy="20.784609690826528" r="0.24" />
      <circle cx="16" cy="21.650635094610966" r="0.24" />
      <circle cx="17" cy="21.650635094610966" r="0.24" />
      <circle cx="18" cy="21.650635094610966" r="0.24" />
      <circle cx="19" cy="21.650635094610966" r="0.24" />
      <circle cx="20" cy="21.650635094610966" r="0.24" />
      <circle cx="46" cy="21.650635094610966" r="0.24" />
      <circle cx="47" cy="21.650635094610966" r="0.24" />
      <circle cx="48" cy="21.650635094610966" r="0.24" />
      <circle cx="49" cy="21.650635094610966" r="0.24" />
      <circle cx="50" cy="21.650635094610966" r="0.24" />
      <circle cx="51" cy="21.650635094610966" r="0.24" />
      <circle cx="52" cy="21.650635094610966" r="0.24" />
      <circle cx="53" cy="21.650635094610966" r="0.24" />
      <circle cx="54" cy="21.650635094610966" r="0.24" />
      <circle cx="55" cy="21.650635094610966" r="0.24" />
      <circle cx="56" cy="21.650635094610966" r="0.24" />
      <circle cx="57" cy="21.650635094610966" r="0.24" />
      <circle cx="58" cy="21.650635094610966" r="0.24" />
      <circle cx="59" cy="21.650635094610966" r="0.24" />
      <circle cx="60" cy="21.650635094610966" r="0.24" />
      <circle cx="61" cy="21.650635094610966" r="0.24" />
      <circle cx="62" cy="21.650635094610966" r="0.24" />
      <circle cx="63" cy="21.650635094610966" r="0.24" />
      <circle cx="65" cy="21.650635094610966" r="0.24" />
      <circle cx="66" cy="21.650635094610966" r="0.24" />
      <circle cx="67" cy="21.650635094610966" r="0.24" />
      <circle cx="68" cy="21.650635094610966" r="0.24" />
      <circle cx="69" cy="21.650635094610966" r="0.24" />
      <circle cx="70" cy="21.650635094610966" r="0.24" />
      <circle cx="71" cy="21.650635094610966" r="0.24" />
      <circle cx="72" cy="21.650635094610966" r="0.24" />
      <circle cx="73" cy="21.650635094610966" r="0.24" />
      <circle cx="74" cy="21.650635094610966" r="0.24" />
      <circle cx="75" cy="21.650635094610966" r="0.24" />
      <circle cx="76" cy="21.650635094610966" r="0.24" />
      <circle cx="77" cy="21.650635094610966" r="0.24" />
      <circle cx="78" cy="21.650635094610966" r="0.24" />
      <circle cx="79" cy="21.650635094610966" r="0.24" />
      <circle cx="80" cy="21.650635094610966" r="0.24" />
      <circle cx="81" cy="21.650635094610966" r="0.24" />
      <circle cx="82" cy="21.650635094610966" r="0.24" />
      <circle cx="83" cy="21.650635094610966" r="0.24" />
      <circle cx="84" cy="21.650635094610966" r="0.24" />
      <circle cx="85" cy="21.650635094610966" r="0.24" />
      <circle cx="16.5" cy="22.516660498395403" r="0.24" />
      <circle cx="18.5" cy="22.516660498395403" r="0.24" />
      <circle cx="19.5" cy="22.516660498395403" r="0.24" />
      <circle cx="20.5" cy="22.516660498395403" r="0.24" />
      <circle cx="26.5" cy="22.516660498395403" r="0.24" />
      <circle cx="45.5" cy="22.516660498395403" r="0.24" />
      <circle cx="46.5" cy="22.516660498395403" r="0.24" />
      <circle cx="47.5" cy="22.516660498395403" r="0.24" />
      <circle cx="48.5" cy="22.516660498395403" r="0.24" />
      <circle cx="49.5" cy="22.516660498395403" r="0.24" />
      <circle cx="50.5" cy="22.516660498395403" r="0.24" />
      <circle cx="51.5" cy="22.516660498395403" r="0.24" />
      <circle cx="52.5" cy="22.516660498395403" r="0.24" />
      <circle cx="53.5" cy="22.516660498395403" r="0.24" />
      <circle cx="54.5" cy="22.516660498395403" r="0.24" />
      <circle cx="55.5" cy="22.516660498395403" r="0.24" />
      <circle cx="56.5" cy="22.516660498395403" r="0.24" />
      <circle cx="57.5" cy="22.516660498395403" r="0.24" />
      <circle cx="58.5" cy="22.516660498395403" r="0.24" />
      <circle cx="59.5" cy="22.516660498395403" r="0.24" />
      <circle cx="60.5" cy="22.516660498395403" r="0.24" />
      <circle cx="61.5" cy="22.516660498395403" r="0.24" />
      <circle cx="62.5" cy="22.516660498395403" r="0.24" />
      <circle cx="63.5" cy="22.516660498395403" r="0.24" />
      <circle cx="64.5" cy="22.516660498395403" r="0.24" />
      <circle cx="69.5" cy="22.516660498395403" r="0.24" />
      <circle cx="70.5" cy="22.516660498395403" r="0.24" />
      <circle cx="71.5" cy="22.516660498395403" r="0.24" />
      <circle cx="72.5" cy="22.516660498395403" r="0.24" />
      <circle cx="73.5" cy="22.516660498395403" r="0.24" />
      <circle cx="74.5" cy="22.516660498395403" r="0.24" />
      <circle cx="75.5" cy="22.516660498395403" r="0.24" />
      <circle cx="76.5" cy="22.516660498395403" r="0.24" />
      <circle cx="77.5" cy="22.516660498395403" r="0.24" />
      <circle cx="78.5" cy="22.516660498395403" r="0.24" />
      <circle cx="79.5" cy="22.516660498395403" r="0.24" />
      <circle cx="80.5" cy="22.516660498395403" r="0.24" />
      <circle cx="81.5" cy="22.516660498395403" r="0.24" />
      <circle cx="82.5" cy="22.516660498395403" r="0.24" />
      <circle cx="83.5" cy="22.516660498395403" r="0.24" />
      <circle cx="84.5" cy="22.516660498395403" r="0.24" />
      <circle cx="19" cy="23.38268590217984" r="0.24" />
      <circle cx="20" cy="23.38268590217984" r="0.24" />
      <circle cx="26" cy="23.38268590217984" r="0.24" />
      <circle cx="45" cy="23.38268590217984" r="0.24" />
      <circle cx="46" cy="23.38268590217984" r="0.24" />
      <circle cx="47" cy="23.38268590217984" r="0.24" />
      <circle cx="48" cy="23.38268590217984" r="0.24" />
      <circle cx="49" cy="23.38268590217984" r="0.24" />
      <circle cx="50" cy="23.38268590217984" r="0.24" />
      <circle cx="51" cy="23.38268590217984" r="0.24" />
      <circle cx="52" cy="23.38268590217984" r="0.24" />
      <circle cx="53" cy="23.38268590217984" r="0.24" />
      <circle cx="54" cy="23.38268590217984" r="0.24" />
      <circle cx="55" cy="23.38268590217984" r="0.24" />
      <circle cx="56" cy="23.38268590217984" r="0.24" />
      <circle cx="57" cy="23.38268590217984" r="0.24" />
      <circle cx="58" cy="23.38268590217984" r="0.24" />
      <circle cx="59" cy="23.38268590217984" r="0.24" />
      <circle cx="60" cy="23.38268590217984" r="0.24" />
      <circle cx="62" cy="23.38268590217984" r="0.24" />
      <circle cx="63" cy="23.38268590217984" r="0.24" />
      <circle cx="64" cy="23.38268590217984" r="0.24" />
      <circle cx="65" cy="23.38268590217984" r="0.24" />
      <circle cx="66" cy="23.38268590217984" r="0.24" />
      <circle cx="67" cy="23.38268590217984" r="0.24" />
      <circle cx="70" cy="23.38268590217984" r="0.24" />
      <circle cx="71" cy="23.38268590217984" r="0.24" />
      <circle cx="72" cy="23.38268590217984" r="0.24" />
      <circle cx="73" cy="23.38268590217984" r="0.24" />
      <circle cx="74" cy="23.38268590217984" r="0.24" />
      <circle cx="75" cy="23.38268590217984" r="0.24" />
      <circle cx="76" cy="23.38268590217984" r="0.24" />
      <circle cx="77" cy="23.38268590217984" r="0.24" />
      <circle cx="78" cy="23.38268590217984" r="0.24" />
      <circle cx="79" cy="23.38268590217984" r="0.24" />
      <circle cx="80" cy="23.38268590217984" r="0.24" />
      <circle cx="81" cy="23.38268590217984" r="0.24" />
      <circle cx="82" cy="23.38268590217984" r="0.24" />
      <circle cx="19.5" cy="24.24871130596428" r="0.24" />
      <circle cx="20.5" cy="24.24871130596428" r="0.24" />
      <circle cx="23.5" cy="24.24871130596428" r="0.24" />
      <circle cx="28.5" cy="24.24871130596428" r="0.24" />
      <circle cx="45.5" cy="24.24871130596428" r="0.24" />
      <circle cx="46.5" cy="24.24871130596428" r="0.24" />
      <circle cx="47.5" cy="24.24871130596428" r="0.24" />
      <circle cx="48.5" cy="24.24871130596428" r="0.24" />
      <circle cx="49.5" cy="24.24871130596428" r="0.24" />
      <circle cx="50.5" cy="24.24871130596428" r="0.24" />
      <circle cx="51.5" cy="24.24871130596428" r="0.24" />
      <circle cx="52.5" cy="24.24871130596428" r="0.24" />
      <circle cx="53.5" cy="24.24871130596428" r="0.24" />
      <circle cx="54.5" cy="24.24871130596428" r="0.24" />
      <circle cx="55.5" cy="24.24871130596428" r="0.24" />
      <circle cx="56.5" cy="24.24871130596428" r="0.24" />
      <circle cx="57.5" cy="24.24871130596428" r="0.24" />
      <circle cx="58.5" cy="24.24871130596428" r="0.24" />
      <circle cx="59.5" cy="24.24871130596428" r="0.24" />
      <circle cx="62.5" cy="24.24871130596428" r="0.24" />
      <circle cx="63.5" cy="24.24871130596428" r="0.24" />
      <circle cx="64.5" cy="24.24871130596428" r="0.24" />
      <circle cx="65.5" cy="24.24871130596428" r="0.24" />
      <circle cx="66.5" cy="24.24871130596428" r="0.24" />
      <circle cx="71.5" cy="24.24871130596428" r="0.24" />
      <circle cx="72.5" cy="24.24871130596428" r="0.24" />
      <circle cx="73.5" cy="24.24871130596428" r="0.24" />
      <circle cx="74.5" cy="24.24871130596428" r="0.24" />
      <circle cx="77.5" cy="24.24871130596428" r="0.24" />
      <circle cx="78.5" cy="24.24871130596428" r="0.24" />
      <circle cx="79.5" cy="24.24871130596428" r="0.24" />
      <circle cx="80.5" cy="24.24871130596428" r="0.24" />
      <circle cx="21" cy="25.11473670974872" r="0.24" />
      <circle cx="22" cy="25.11473670974872" r="0.24" />
      <circle cx="23" cy="25.11473670974872" r="0.24" />
      <circle cx="45" cy="25.11473670974872" r="0.24" />
      <circle cx="46" cy="25.11473670974872" r="0.24" />
      <circle cx="47" cy="25.11473670974872" r="0.24" />
      <circle cx="48" cy="25.11473670974872" r="0.24" />
      <circle cx="49" cy="25.11473670974872" r="0.24" />
      <circle cx="50" cy="25.11473670974872" r="0.24" />
      <circle cx="51" cy="25.11473670974872" r="0.24" />
      <circle cx="52" cy="25.11473670974872" r="0.24" />
      <circle cx="53" cy="25.11473670974872" r="0.24" />
      <circle cx="54" cy="25.11473670974872" r="0.24" />
      <circle cx="55" cy="25.11473670974872" r="0.24" />
      <circle cx="56" cy="25.11473670974872" r="0.24" />
      <circle cx="57" cy="25.11473670974872" r="0.24" />
      <circle cx="58" cy="25.11473670974872" r="0.24" />
      <circle cx="59" cy="25.11473670974872" r="0.24" />
      <circle cx="60" cy="25.11473670974872" r="0.24" />
      <circle cx="63" cy="25.11473670974872" r="0.24" />
      <circle cx="64" cy="25.11473670974872" r="0.24" />
      <circle cx="65" cy="25.11473670974872" r="0.24" />
      <circle cx="72" cy="25.11473670974872" r="0.24" />
      <circle cx="73" cy="25.11473670974872" r="0.24" />
      <circle cx="78" cy="25.11473670974872" r="0.24" />
      <circle cx="79" cy="25.11473670974872" r="0.24" />
      <circle cx="80" cy="25.11473670974872" r="0.24" />
      <circle cx="81" cy="25.11473670974872" r="0.24" />
      <circle cx="85" cy="25.11473670974872" r="0.24" />
      <circle cx="23.5" cy="25.980762113533157" r="0.24" />
      <circle cx="24.5" cy="25.980762113533157" r="0.24" />
      <circle cx="45.5" cy="25.980762113533157" r="0.24" />
      <circle cx="46.5" cy="25.980762113533157" r="0.24" />
      <circle cx="47.5" cy="25.980762113533157" r="0.24" />
      <circle cx="48.5" cy="25.980762113533157" r="0.24" />
      <circle cx="49.5" cy="25.980762113533157" r="0.24" />
      <circle cx="50.5" cy="25.980762113533157" r="0.24" />
      <circle cx="51.5" cy="25.980762113533157" r="0.24" />
      <circle cx="52.5" cy="25.980762113533157" r="0.24" />
      <circle cx="53.5" cy="25.980762113533157" r="0.24" />
      <circle cx="54.5" cy="25.980762113533157" r="0.24" />
      <circle cx="55.5" cy="25.980762113533157" r="0.24" />
      <circle cx="56.5" cy="25.980762113533157" r="0.24" />
      <circle cx="57.5" cy="25.980762113533157" r="0.24" />
      <circle cx="58.5" cy="25.980762113533157" r="0.24" />
      <circle cx="59.5" cy="25.980762113533157" r="0.24" />
      <circle cx="60.5" cy="25.980762113533157" r="0.24" />
      <circle cx="61.5" cy="25.980762113533157" r="0.24" />
      <circle cx="62.5" cy="25.980762113533157" r="0.24" />
      <circle cx="63.5" cy="25.980762113533157" r="0.24" />
      <circle cx="71.5" cy="25.980762113533157" r="0.24" />
      <circle cx="72.5" cy="25.980762113533157" r="0.24" />
      <circle cx="78.5" cy="25.980762113533157" r="0.24" />
      <circle cx="79.5" cy="25.980762113533157" r="0.24" />
      <circle cx="80.5" cy="25.980762113533157" r="0.24" />
      <circle cx="81.5" cy="25.980762113533157" r="0.24" />
      <circle cx="85.5" cy="25.980762113533157" r="0.24" />
      <circle cx="28" cy="26.846787517317598" r="0.24" />
      <circle cx="29" cy="26.846787517317598" r="0.24" />
      <circle cx="46" cy="26.846787517317598" r="0.24" />
      <circle cx="47" cy="26.846787517317598" r="0.24" />
      <circle cx="48" cy="26.846787517317598" r="0.24" />
      <circle cx="49" cy="26.846787517317598" r="0.24" />
      <circle cx="50" cy="26.846787517317598" r="0.24" />
      <circle cx="51" cy="26.846787517317598" r="0.24" />
      <circle cx="52" cy="26.846787517317598" r="0.24" />
      <circle cx="53" cy="26.846787517317598" r="0.24" />
      <circle cx="54" cy="26.846787517317598" r="0.24" />
      <circle cx="55" cy="26.846787517317598" r="0.24" />
      <circle cx="56" cy="26.846787517317598" r="0.24" />
      <circle cx="57" cy="26.846787517317598" r="0.24" />
      <circle cx="58" cy="26.846787517317598" r="0.24" />
      <circle cx="59" cy="26.846787517317598" r="0.24" />
      <circle cx="60" cy="26.846787517317598" r="0.24" />
      <circle cx="61" cy="26.846787517317598" r="0.24" />
      <circle cx="62" cy="26.846787517317598" r="0.24" />
      <circle cx="64" cy="26.846787517317598" r="0.24" />
      <circle cx="72" cy="26.846787517317598" r="0.24" />
      <circle cx="73" cy="26.846787517317598" r="0.24" />
      <circle cx="80" cy="26.846787517317598" r="0.24" />
      <circle cx="81" cy="26.846787517317598" r="0.24" />
      <circle cx="25.5" cy="27.712812921102035" r="0.24" />
      <circle cx="26.5" cy="27.712812921102035" r="0.24" />
      <circle cx="27.5" cy="27.712812921102035" r="0.24" />
      <circle cx="28.5" cy="27.712812921102035" r="0.24" />
      <circle cx="29.5" cy="27.712812921102035" r="0.24" />
      <circle cx="30.5" cy="27.712812921102035" r="0.24" />
      <circle cx="31.5" cy="27.712812921102035" r="0.24" />
      <circle cx="46.5" cy="27.712812921102035" r="0.24" />
      <circle cx="47.5" cy="27.712812921102035" r="0.24" />
      <circle cx="48.5" cy="27.712812921102035" r="0.24" />
      <circle cx="49.5" cy="27.712812921102035" r="0.24" />
      <circle cx="50.5" cy="27.712812921102035" r="0.24" />
      <circle cx="51.5" cy="27.712812921102035" r="0.24" />
      <circle cx="52.5" cy="27.712812921102035" r="0.24" />
      <circle cx="53.5" cy="27.712812921102035" r="0.24" />
      <circle cx="54.5" cy="27.712812921102035" r="0.24" />
      <circle cx="55.5" cy="27.712812921102035" r="0.24" />
      <circle cx="56.5" cy="27.712812921102035" r="0.24" />
      <circle cx="57.5" cy="27.712812921102035" r="0.24" />
      <circle cx="58.5" cy="27.712812921102035" r="0.24" />
      <circle cx="59.5" cy="27.712812921102035" r="0.24" />
      <circle cx="60.5" cy="27.712812921102035" r="0.24" />
      <circle cx="61.5" cy="27.712812921102035" r="0.24" />
      <circle cx="62.5" cy="27.712812921102035" r="0.24" />
      <circle cx="63.5" cy="27.712812921102035" r="0.24" />
      <circle cx="73.5" cy="27.712812921102035" r="0.24" />
      <circle cx="86.5" cy="27.712812921102035" r="0.24" />
      <circle cx="27" cy="28.578838324886473" r="0.24" />
      <circle cx="28" cy="28.578838324886473" r="0.24" />
      <circle cx="29" cy="28.578838324886473" r="0.24" />
      <circle cx="30" cy="28.578838324886473" r="0.24" />
      <circle cx="31" cy="28.578838324886473" r="0.24" />
      <circle cx="32" cy="28.578838324886473" r="0.24" />
      <circle cx="33" cy="28.578838324886473" r="0.24" />
      <circle cx="34" cy="28.578838324886473" r="0.24" />
      <circle cx="47" cy="28.578838324886473" r="0.24" />
      <circle cx="48" cy="28.578838324886473" r="0.24" />
      <circle cx="49" cy="28.578838324886473" r="0.24" />
      <circle cx="52" cy="28.578838324886473" r="0.24" />
      <circle cx="53" cy="28.578838324886473" r="0.24" />
      <circle cx="54" cy="28.578838324886473" r="0.24" />
      <circle cx="55" cy="28.578838324886473" r="0.24" />
      <circle cx="56" cy="28.578838324886473" r="0.24" />
      <circle cx="57" cy="28.578838324886473" r="0.24" />
      <circle cx="58" cy="28.578838324886473" r="0.24" />
      <circle cx="59" cy="28.578838324886473" r="0.24" />
      <circle cx="60" cy="28.578838324886473" r="0.24" />
      <circle cx="61" cy="28.578838324886473" r="0.24" />
      <circle cx="62" cy="28.578838324886473" r="0.24" />
      <circle cx="63" cy="28.578838324886473" r="0.24" />
      <circle cx="78" cy="28.578838324886473" r="0.24" />
      <circle cx="84" cy="28.578838324886473" r="0.24" />
      <circle cx="26.5" cy="29.444863728670914" r="0.24" />
      <circle cx="27.5" cy="29.444863728670914" r="0.24" />
      <circle cx="28.5" cy="29.444863728670914" r="0.24" />
      <circle cx="29.5" cy="29.444863728670914" r="0.24" />
      <circle cx="30.5" cy="29.444863728670914" r="0.24" />
      <circle cx="31.5" cy="29.444863728670914" r="0.24" />
      <circle cx="32.5" cy="29.444863728670914" r="0.24" />
      <circle cx="33.5" cy="29.444863728670914" r="0.24" />
      <circle cx="34.5" cy="29.444863728670914" r="0.24" />
      <circle cx="52.5" cy="29.444863728670914" r="0.24" />
      <circle cx="53.5" cy="29.444863728670914" r="0.24" />
      <circle cx="54.5" cy="29.444863728670914" r="0.24" />
      <circle cx="55.5" cy="29.444863728670914" r="0.24" />
      <circle cx="56.5" cy="29.444863728670914" r="0.24" />
      <circle cx="57.5" cy="29.444863728670914" r="0.24" />
      <circle cx="58.5" cy="29.444863728670914" r="0.24" />
      <circle cx="59.5" cy="29.444863728670914" r="0.24" />
      <circle cx="60.5" cy="29.444863728670914" r="0.24" />
      <circle cx="61.5" cy="29.444863728670914" r="0.24" />
      <circle cx="62.5" cy="29.444863728670914" r="0.24" />
      <circle cx="78.5" cy="29.444863728670914" r="0.24" />
      <circle cx="82.5" cy="29.444863728670914" r="0.24" />
      <circle cx="83.5" cy="29.444863728670914" r="0.24" />
      <circle cx="26" cy="30.31088913245535" r="0.24" />
      <circle cx="27" cy="30.31088913245535" r="0.24" />
      <circle cx="28" cy="30.31088913245535" r="0.24" />
      <circle cx="29" cy="30.31088913245535" r="0.24" />
      <circle cx="30" cy="30.31088913245535" r="0.24" />
      <circle cx="31" cy="30.31088913245535" r="0.24" />
      <circle cx="32" cy="30.31088913245535" r="0.24" />
      <circle cx="33" cy="30.31088913245535" r="0.24" />
      <circle cx="34" cy="30.31088913245535" r="0.24" />
      <circle cx="35" cy="30.31088913245535" r="0.24" />
      <circle cx="53" cy="30.31088913245535" r="0.24" />
      <circle cx="54" cy="30.31088913245535" r="0.24" />
      <circle cx="55" cy="30.31088913245535" r="0.24" />
      <circle cx="56" cy="30.31088913245535" r="0.24" />
      <circle cx="57" cy="30.31088913245535" r="0.24" />
      <circle cx="58" cy="30.31088913245535" r="0.24" />
      <circle cx="59" cy="30.31088913245535" r="0.24" />
      <circle cx="60" cy="30.31088913245535" r="0.24" />
      <circle cx="61" cy="30.31088913245535" r="0.24" />
      <circle cx="80" cy="30.31088913245535" r="0.24" />
      <circle cx="82" cy="30.31088913245535" r="0.24" />
      <circle cx="83" cy="30.31088913245535" r="0.24" />
      <circle cx="84" cy="30.31088913245535" r="0.24" />
      <circle cx="26.5" cy="31.17691453623979" r="0.24" />
      <circle cx="27.5" cy="31.17691453623979" r="0.24" />
      <circle cx="28.5" cy="31.17691453623979" r="0.24" />
      <circle cx="29.5" cy="31.17691453623979" r="0.24" />
      <circle cx="30.5" cy="31.17691453623979" r="0.24" />
      <circle cx="31.5" cy="31.17691453623979" r="0.24" />
      <circle cx="32.5" cy="31.17691453623979" r="0.24" />
      <circle cx="33.5" cy="31.17691453623979" r="0.24" />
      <circle cx="34.5" cy="31.17691453623979" r="0.24" />
      <circle cx="35.5" cy="31.17691453623979" r="0.24" />
      <circle cx="36.5" cy="31.17691453623979" r="0.24" />
      <circle cx="37.5" cy="31.17691453623979" r="0.24" />
      <circle cx="53.5" cy="31.17691453623979" r="0.24" />
      <circle cx="54.5" cy="31.17691453623979" r="0.24" />
      <circle cx="55.5" cy="31.17691453623979" r="0.24" />
      <circle cx="56.5" cy="31.17691453623979" r="0.24" />
      <circle cx="57.5" cy="31.17691453623979" r="0.24" />
      <circle cx="58.5" cy="31.17691453623979" r="0.24" />
      <circle cx="59.5" cy="31.17691453623979" r="0.24" />
      <circle cx="60.5" cy="31.17691453623979" r="0.24" />
      <circle cx="80.5" cy="31.17691453623979" r="0.24" />
      <circle cx="83.5" cy="31.17691453623979" r="0.24" />
      <circle cx="85.5" cy="31.17691453623979" r="0.24" />
      <circle cx="89.5" cy="31.17691453623979" r="0.24" />
      <circle cx="90.5" cy="31.17691453623979" r="0.24" />
      <circle cx="91.5" cy="31.17691453623979" r="0.24" />
      <circle cx="94.5" cy="31.17691453623979" r="0.24" />
      <circle cx="26" cy="32.042939940024226" r="0.24" />
      <circle cx="27" cy="32.042939940024226" r="0.24" />
      <circle cx="28" cy="32.042939940024226" r="0.24" />
      <circle cx="29" cy="32.042939940024226" r="0.24" />
      <circle cx="30" cy="32.042939940024226" r="0.24" />
      <circle cx="31" cy="32.042939940024226" r="0.24" />
      <circle cx="32" cy="32.042939940024226" r="0.24" />
      <circle cx="33" cy="32.042939940024226" r="0.24" />
      <circle cx="34" cy="32.042939940024226" r="0.24" />
      <circle cx="35" cy="32.042939940024226" r="0.24" />
      <circle cx="36" cy="32.042939940024226" r="0.24" />
      <circle cx="37" cy="32.042939940024226" r="0.24" />
      <circle cx="38" cy="32.042939940024226" r="0.24" />
      <circle cx="39" cy="32.042939940024226" r="0.24" />
      <circle cx="54" cy="32.042939940024226" r="0.24" />
      <circle cx="55" cy="32.042939940024226" r="0.24" />
      <circle cx="56" cy="32.042939940024226" r="0.24" />
      <circle cx="57" cy="32.042939940024226" r="0.24" />
      <circle cx="58" cy="32.042939940024226" r="0.24" />
      <circle cx="59" cy="32.042939940024226" r="0.24" />
      <circle cx="60" cy="32.042939940024226" r="0.24" />
      <circle cx="61" cy="32.042939940024226" r="0.24" />
      <circle cx="81" cy="32.042939940024226" r="0.24" />
      <circle cx="91" cy="32.042939940024226" r="0.24" />
      <circle cx="92" cy="32.042939940024226" r="0.24" />
      <circle cx="26.5" cy="32.90896534380867" r="0.24" />
      <circle cx="27.5" cy="32.90896534380867" r="0.24" />
      <circle cx="28.5" cy="32.90896534380867" r="0.24" />
      <circle cx="29.5" cy="32.90896534380867" r="0.24" />
      <circle cx="30.5" cy="32.90896534380867" r="0.24" />
      <circle cx="31.5" cy="32.90896534380867" r="0.24" />
      <circle cx="32.5" cy="32.90896534380867" r="0.24" />
      <circle cx="33.5" cy="32.90896534380867" r="0.24" />
      <circle cx="34.5" cy="32.90896534380867" r="0.24" />
      <circle cx="35.5" cy="32.90896534380867" r="0.24" />
      <circle cx="36.5" cy="32.90896534380867" r="0.24" />
      <circle cx="37.5" cy="32.90896534380867" r="0.24" />
      <circle cx="38.5" cy="32.90896534380867" r="0.24" />
      <circle cx="53.5" cy="32.90896534380867" r="0.24" />
      <circle cx="54.5" cy="32.90896534380867" r="0.24" />
      <circle cx="55.5" cy="32.90896534380867" r="0.24" />
      <circle cx="56.5" cy="32.90896534380867" r="0.24" />
      <circle cx="57.5" cy="32.90896534380867" r="0.24" />
      <circle cx="58.5" cy="32.90896534380867" r="0.24" />
      <circle cx="59.5" cy="32.90896534380867" r="0.24" />
      <circle cx="60.5" cy="32.90896534380867" r="0.24" />
      <circle cx="93.5" cy="32.90896534380867" r="0.24" />
      <circle cx="27" cy="33.77499074759311" r="0.24" />
      <circle cx="28" cy="33.77499074759311" r="0.24" />
      <circle cx="29" cy="33.77499074759311" r="0.24" />
      <circle cx="30" cy="33.77499074759311" r="0.24" />
      <circle cx="31" cy="33.77499074759311" r="0.24" />
      <circle cx="32" cy="33.77499074759311" r="0.24" />
      <circle cx="33" cy="33.77499074759311" r="0.24" />
      <circle cx="34" cy="33.77499074759311" r="0.24" />
      <circle cx="35" cy="33.77499074759311" r="0.24" />
      <circle cx="36" cy="33.77499074759311" r="0.24" />
      <circle cx="37" cy="33.77499074759311" r="0.24" />
      <circle cx="38" cy="33.77499074759311" r="0.24" />
      <circle cx="54" cy="33.77499074759311" r="0.24" />
      <circle cx="55" cy="33.77499074759311" r="0.24" />
      <circle cx="56" cy="33.77499074759311" r="0.24" />
      <circle cx="57" cy="33.77499074759311" r="0.24" />
      <circle cx="58" cy="33.77499074759311" r="0.24" />
      <circle cx="59" cy="33.77499074759311" r="0.24" />
      <circle cx="60" cy="33.77499074759311" r="0.24" />
      <circle cx="61" cy="33.77499074759311" r="0.24" />
      <circle cx="64" cy="33.77499074759311" r="0.24" />
      <circle cx="88" cy="33.77499074759311" r="0.24" />
      <circle cx="89" cy="33.77499074759311" r="0.24" />
      <circle cx="27.5" cy="34.64101615137754" r="0.24" />
      <circle cx="28.5" cy="34.64101615137754" r="0.24" />
      <circle cx="29.5" cy="34.64101615137754" r="0.24" />
      <circle cx="30.5" cy="34.64101615137754" r="0.24" />
      <circle cx="31.5" cy="34.64101615137754" r="0.24" />
      <circle cx="32.5" cy="34.64101615137754" r="0.24" />
      <circle cx="33.5" cy="34.64101615137754" r="0.24" />
      <circle cx="34.5" cy="34.64101615137754" r="0.24" />
      <circle cx="35.5" cy="34.64101615137754" r="0.24" />
      <circle cx="36.5" cy="34.64101615137754" r="0.24" />
      <circle cx="37.5" cy="34.64101615137754" r="0.24" />
      <circle cx="53.5" cy="34.64101615137754" r="0.24" />
      <circle cx="54.5" cy="34.64101615137754" r="0.24" />
      <circle cx="55.5" cy="34.64101615137754" r="0.24" />
      <circle cx="56.5" cy="34.64101615137754" r="0.24" />
      <circle cx="57.5" cy="34.64101615137754" r="0.24" />
      <circle cx="58.5" cy="34.64101615137754" r="0.24" />
      <circle cx="59.5" cy="34.64101615137754" r="0.24" />
      <circle cx="60.5" cy="34.64101615137754" r="0.24" />
      <circle cx="63.5" cy="34.64101615137754" r="0.24" />
      <circle cx="86.5" cy="34.64101615137754" r="0.24" />
      <circle cx="87.5" cy="34.64101615137754" r="0.24" />
      <circle cx="88.5" cy="34.64101615137754" r="0.24" />
      <circle cx="89.5" cy="34.64101615137754" r="0.24" />
      <circle cx="91.5" cy="34.64101615137754" r="0.24" />
      <circle cx="29" cy="35.50704155516198" r="0.24" />
      <circle cx="30" cy="35.50704155516198" r="0.24" />
      <circle cx="31" cy="35.50704155516198" r="0.24" />
      <circle cx="32" cy="35.50704155516198" r="0.24" />
      <circle cx="33" cy="35.50704155516198" r="0.24" />
      <circle cx="34" cy="35.50704155516198" r="0.24" />
      <circle cx="35" cy="35.50704155516198" r="0.24" />
      <circle cx="36" cy="35.50704155516198" r="0.24" />
      <circle cx="37" cy="35.50704155516198" r="0.24" />
      <circle cx="54" cy="35.50704155516198" r="0.24" />
      <circle cx="55" cy="35.50704155516198" r="0.24" />
      <circle cx="56" cy="35.50704155516198" r="0.24" />
      <circle cx="57" cy="35.50704155516198" r="0.24" />
      <circle cx="58" cy="35.50704155516198" r="0.24" />
      <circle cx="59" cy="35.50704155516198" r="0.24" />
      <circle cx="60" cy="35.50704155516198" r="0.24" />
      <circle cx="63" cy="35.50704155516198" r="0.24" />
      <circle cx="64" cy="35.50704155516198" r="0.24" />
      <circle cx="86" cy="35.50704155516198" r="0.24" />
      <circle cx="87" cy="35.50704155516198" r="0.24" />
      <circle cx="88" cy="35.50704155516198" r="0.24" />
      <circle cx="89" cy="35.50704155516198" r="0.24" />
      <circle cx="90" cy="35.50704155516198" r="0.24" />
      <circle cx="91" cy="35.50704155516198" r="0.24" />
      <circle cx="92" cy="35.50704155516198" r="0.24" />
      <circle cx="29.5" cy="36.373066958946424" r="0.24" />
      <circle cx="30.5" cy="36.373066958946424" r="0.24" />
      <circle cx="31.5" cy="36.373066958946424" r="0.24" />
      <circle cx="32.5" cy="36.373066958946424" r="0.24" />
      <circle cx="33.5" cy="36.373066958946424" r="0.24" />
      <circle cx="34.5" cy="36.373066958946424" r="0.24" />
      <circle cx="35.5" cy="36.373066958946424" r="0.24" />
      <circle cx="36.5" cy="36.373066958946424" r="0.24" />
      <circle cx="53.5" cy="36.373066958946424" r="0.24" />
      <circle cx="54.5" cy="36.373066958946424" r="0.24" />
      <circle cx="55.5" cy="36.373066958946424" r="0.24" />
      <circle cx="56.5" cy="36.373066958946424" r="0.24" />
      <circle cx="57.5" cy="36.373066958946424" r="0.24" />
      <circle cx="58.5" cy="36.373066958946424" r="0.24" />
      <circle cx="59.5" cy="36.373066958946424" r="0.24" />
      <circle cx="62.5" cy="36.373066958946424" r="0.24" />
      <circle cx="63.5" cy="36.373066958946424" r="0.24" />
      <circle cx="84.5" cy="36.373066958946424" r="0.24" />
      <circle cx="85.5" cy="36.373066958946424" r="0.24" />
      <circle cx="86.5" cy="36.373066958946424" r="0.24" />
      <circle cx="87.5" cy="36.373066958946424" r="0.24" />
      <circle cx="88.5" cy="36.373066958946424" r="0.24" />
      <circle cx="89.5" cy="36.373066958946424" r="0.24" />
      <circle cx="90.5" cy="36.373066958946424" r="0.24" />
      <circle cx="91.5" cy="36.373066958946424" r="0.24" />
      <circle cx="92.5" cy="36.373066958946424" r="0.24" />
      <circle cx="29" cy="37.23909236273086" r="0.24" />
      <circle cx="30" cy="37.23909236273086" r="0.24" />
      <circle cx="31" cy="37.23909236273086" r="0.24" />
      <circle cx="32" cy="37.23909236273086" r="0.24" />
      <circle cx="33" cy="37.23909236273086" r="0.24" />
      <circle cx="34" cy="37.23909236273086" r="0.24" />
      <circle cx="35" cy="37.23909236273086" r="0.24" />
      <circle cx="36" cy="37.23909236273086" r="0.24" />
      <circle cx="54" cy="37.23909236273086" r="0.24" />
      <circle cx="55" cy="37.23909236273086" r="0.24" />
      <circle cx="56" cy="37.23909236273086" r="0.24" />
      <circle cx="57" cy="37.23909236273086" r="0.24" />
      <circle cx="58" cy="37.23909236273086" r="0.24" />
      <circle cx="59" cy="37.23909236273086" r="0.24" />
      <circle cx="63" cy="37.23909236273086" r="0.24" />
      <circle cx="83" cy="37.23909236273086" r="0.24" />
      <circle cx="84" cy="37.23909236273086" r="0.24" />
      <circle cx="85" cy="37.23909236273086" r="0.24" />
      <circle cx="86" cy="37.23909236273086" r="0.24" />
      <circle cx="87" cy="37.23909236273086" r="0.24" />
      <circle cx="88" cy="37.23909236273086" r="0.24" />
      <circle cx="89" cy="37.23909236273086" r="0.24" />
      <circle cx="90" cy="37.23909236273086" r="0.24" />
      <circle cx="91" cy="37.23909236273086" r="0.24" />
      <circle cx="92" cy="37.23909236273086" r="0.24" />
      <circle cx="93" cy="37.23909236273086" r="0.24" />
      <circle cx="94" cy="37.23909236273086" r="0.24" />
      <circle cx="29.5" cy="38.1051177665153" r="0.24" />
      <circle cx="30.5" cy="38.1051177665153" r="0.24" />
      <circle cx="31.5" cy="38.1051177665153" r="0.24" />
      <circle cx="32.5" cy="38.1051177665153" r="0.24" />
      <circle cx="33.5" cy="38.1051177665153" r="0.24" />
      <circle cx="34.5" cy="38.1051177665153" r="0.24" />
      <circle cx="54.5" cy="38.1051177665153" r="0.24" />
      <circle cx="55.5" cy="38.1051177665153" r="0.24" />
      <circle cx="56.5" cy="38.1051177665153" r="0.24" />
      <circle cx="57.5" cy="38.1051177665153" r="0.24" />
      <circle cx="58.5" cy="38.1051177665153" r="0.24" />
      <circle cx="83.5" cy="38.1051177665153" r="0.24" />
      <circle cx="84.5" cy="38.1051177665153" r="0.24" />
      <circle cx="85.5" cy="38.1051177665153" r="0.24" />
      <circle cx="86.5" cy="38.1051177665153" r="0.24" />
      <circle cx="87.5" cy="38.1051177665153" r="0.24" />
      <circle cx="88.5" cy="38.1051177665153" r="0.24" />
      <circle cx="89.5" cy="38.1051177665153" r="0.24" />
      <circle cx="90.5" cy="38.1051177665153" r="0.24" />
      <circle cx="91.5" cy="38.1051177665153" r="0.24" />
      <circle cx="92.5" cy="38.1051177665153" r="0.24" />
      <circle cx="93.5" cy="38.1051177665153" r="0.24" />
      <circle cx="94.5" cy="38.1051177665153" r="0.24" />
      <circle cx="29" cy="38.97114317029974" r="0.24" />
      <circle cx="30" cy="38.97114317029974" r="0.24" />
      <circle cx="31" cy="38.97114317029974" r="0.24" />
      <circle cx="32" cy="38.97114317029974" r="0.24" />
      <circle cx="33" cy="38.97114317029974" r="0.24" />
      <circle cx="34" cy="38.97114317029974" r="0.24" />
      <circle cx="55" cy="38.97114317029974" r="0.24" />
      <circle cx="56" cy="38.97114317029974" r="0.24" />
      <circle cx="57" cy="38.97114317029974" r="0.24" />
      <circle cx="58" cy="38.97114317029974" r="0.24" />
      <circle cx="84" cy="38.97114317029974" r="0.24" />
      <circle cx="85" cy="38.97114317029974" r="0.24" />
      <circle cx="86" cy="38.97114317029974" r="0.24" />
      <circle cx="87" cy="38.97114317029974" r="0.24" />
      <circle cx="88" cy="38.97114317029974" r="0.24" />
      <circle cx="89" cy="38.97114317029974" r="0.24" />
      <circle cx="90" cy="38.97114317029974" r="0.24" />
      <circle cx="91" cy="38.97114317029974" r="0.24" />
      <circle cx="92" cy="38.97114317029974" r="0.24" />
      <circle cx="93" cy="38.97114317029974" r="0.24" />
      <circle cx="94" cy="38.97114317029974" r="0.24" />
      <circle cx="28.5" cy="39.837168574084174" r="0.24" />
      <circle cx="29.5" cy="39.837168574084174" r="0.24" />
      <circle cx="30.5" cy="39.837168574084174" r="0.24" />
      <circle cx="31.5" cy="39.837168574084174" r="0.24" />
      <circle cx="32.5" cy="39.837168574084174" r="0.24" />
      <circle cx="33.5" cy="39.837168574084174" r="0.24" />
      <circle cx="55.5" cy="39.837168574084174" r="0.24" />
      <circle cx="56.5" cy="39.837168574084174" r="0.24" />
      <circle cx="57.5" cy="39.837168574084174" r="0.24" />
      <circle cx="84.5" cy="39.837168574084174" r="0.24" />
      <circle cx="85.5" cy="39.837168574084174" r="0.24" />
      <circle cx="86.5" cy="39.837168574084174" r="0.24" />
      <circle cx="87.5" cy="39.837168574084174" r="0.24" />
      <circle cx="88.5" cy="39.837168574084174" r="0.24" />
      <circle cx="89.5" cy="39.837168574084174" r="0.24" />
      <circle cx="90.5" cy="39.837168574084174" r="0.24" />
      <circle cx="91.5" cy="39.837168574084174" r="0.24" />
      <circle cx="92.5" cy="39.837168574084174" r="0.24" />
      <circle cx="93.5" cy="39.837168574084174" r="0.24" />
      <circle cx="94.5" cy="39.837168574084174" r="0.24" />
      <circle cx="29" cy="40.703193977868615" r="0.24" />
      <circle cx="30" cy="40.703193977868615" r="0.24" />
      <circle cx="31" cy="40.703193977868615" r="0.24" />
      <circle cx="32" cy="40.703193977868615" r="0.24" />
      <circle cx="33" cy="40.703193977868615" r="0.24" />
      <circle cx="55" cy="40.703193977868615" r="0.24" />
      <circle cx="56" cy="40.703193977868615" r="0.24" />
      <circle cx="84" cy="40.703193977868615" r="0.24" />
      <circle cx="91" cy="40.703193977868615" r="0.24" />
      <circle cx="92" cy="40.703193977868615" r="0.24" />
      <circle cx="93" cy="40.703193977868615" r="0.24" />
      <circle cx="94" cy="40.703193977868615" r="0.24" />
      <circle cx="28.5" cy="41.569219381653056" r="0.24" />
      <circle cx="29.5" cy="41.569219381653056" r="0.24" />
      <circle cx="30.5" cy="41.569219381653056" r="0.24" />
      <circle cx="31.5" cy="41.569219381653056" r="0.24" />
      <circle cx="32.5" cy="41.569219381653056" r="0.24" />
      <circle cx="91.5" cy="41.569219381653056" r="0.24" />
      <circle cx="92.5" cy="41.569219381653056" r="0.24" />
      <circle cx="93.5" cy="41.569219381653056" r="0.24" />
      <circle cx="28" cy="42.43524478543749" r="0.24" />
      <circle cx="29" cy="42.43524478543749" r="0.24" />
      <circle cx="30" cy="42.43524478543749" r="0.24" />
      <circle cx="31" cy="42.43524478543749" r="0.24" />
      <circle cx="28.5" cy="43.30127018922193" r="0.24" />
      <circle cx="29.5" cy="43.30127018922193" r="0.24" />
      <circle cx="92.5" cy="43.30127018922193" r="0.24" />
      <circle cx="29" cy="44.167295593006365" r="0.24" />
      <circle cx="30" cy="44.167295593006365" r="0.24" />
      <circle cx="28.5" cy="45.033320996790806" r="0.24" />
      <circle cx="29.5" cy="45.033320996790806" r="0.24" />
      <circle cx="28" cy="45.89934640057525" r="0.24" />
      <circle cx="29" cy="45.89934640057525" r="0.24" />
      <circle cx="30" cy="45.89934640057525" r="0.24" />
      <circle cx="27.5" cy="46.76537180435968" r="0.24" />
      <circle cx="28.5" cy="46.76537180435968" r="0.24" />
      <circle cx="29.5" cy="46.76537180435968" r="0.24" />
      <circle cx="28" cy="47.63139720814412" r="0.24" />
      <circle cx="29" cy="47.63139720814412" r="0.24" />
      <circle cx="28.5" cy="48.49742261192856" r="0.24" />
      <circle cx="29" cy="49.363448015713" r="0.24" />
      <circle cx="30" cy="49.363448015713" r="0.24" />
    </svg>
  );
}